import React, { useState, useEffect } from 'react';
import { supabase } from '../../../supabaseClient';
import { useNavigate } from 'react-router-dom';
import Tutorial from '../../../components/Tutorial/Tutorial';
import { TUTORIALES } from '../../../constants/tutorialesConfig';

// ── Emblemas prediseñados ─────────────────────────────────────────────────────
const EMBLEMAS = {
  escudo_1:  '🛡️', escudo_2: '⚔️', estrella:  '⭐', corona:   '👑',
  fuego:     '🔥', rayo:     '⚡', trofeo:    '🏆', dragon:   '🐉',
  aguila:    '🦅', leon:     '🦁', lobo:      '🐺', toro:     '🐂',
  planeta:   '🌍', diamante: '💎', cohete:    '🚀', calavera: '💀',
};

const COLORES = [
  '#00f2ff','#ff007f','#22c55e','#f59e0b','#a855f7',
  '#ef4444','#3b82f6','#f97316','#14b8a6','#ec4899',
];

const calcularRango = (pts) => {
  if (pts >= 1500) return { nombre: 'DTXI',        icono: '👑', color: '#f59e0b' };
  if (pts >= 1000) return { nombre: 'Leyenda',     icono: '🔴', color: '#ef4444' };
  if (pts >= 600)  return { nombre: 'Maestro',     icono: '🟠', color: '#f97316' };
  if (pts >= 300)  return { nombre: 'Elite',       icono: '🟣', color: '#a855f7' };
  if (pts >= 100)  return { nombre: 'Veterano',    icono: '🔵', color: '#3b82f6' };
  return             { nombre: 'Rookie',       icono: '⚪', color: '#94a3b8' };
};


// ── Loader compartido ──────────────────────────────────────────────────────
const Loader = ({ texto = 'Cargando...' }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: '20px' }}>
    <div style={{ position: 'relative', width: '56px', height: '56px' }}>
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '3px solid #0f172a' }} />
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '3px solid transparent', borderTopColor: '#00f2ff', animation: 'spin 0.9s linear infinite' }} />
      <div style={{ position: 'absolute', inset: '8px', borderRadius: '50%', border: '2px solid transparent', borderTopColor: '#a855f7', animation: 'spin 1.4s linear infinite reverse' }} />
    </div>
    <p style={{ color: '#475569', fontSize: '0.82rem', letterSpacing: '2px', textTransform: 'uppercase', margin: 0 }}>{texto}</p>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

// ── Componente principal ──────────────────────────────────────────────────────
const ClanPage = ({ session }) => {
  const navigate = useNavigate();
  const [vista, setVista] = useState('loading');
  const [miClan, setMiClan]       = useState(null);
  const [miembros, setMiembros]   = useState([]);
  const [perfilRanked, setPerfilRanked] = useState(null);
  const [msg, setMsg]             = useState('');

  // Formulario crear clan
  const [formNombre, setFormNombre]     = useState('');
  const [formTag, setFormTag]           = useState('');
  const [formDesc, setFormDesc]         = useState('');
  const [formEmblema, setFormEmblema]   = useState('escudo_1');
  const [formColor, setFormColor]       = useState('#00f2ff');
  const [formTipo, setFormTipo]         = useState('abierto');
  const [creando, setCreando]           = useState(false);

  // Unirse a clan
  const [codigoUnirse, setCodigoUnirse] = useState('');
  const [uniendose, setUniendose]       = useState(false);
  const [clanList, setClanList]         = useState([]);

  // Editar clan
  const [guardandoEdicion, setGuardandoEdicion] = useState(false);

  // Torneos del clan
  const [torneosClan, setTorneosClan]     = useState([]);
  const [mostrarCrearTorneo, setMostrarCrearTorneo] = useState(false);
  const [torneoNombre, setTorneoNombre]   = useState('');
  const [torneoTipo, setTorneoTipo]       = useState('tactico');
  const [creandoTorneo, setCreandoTorneo] = useState(false);

  // Palmarés del clan
  const [historiaFechasClan, setHistoriaFechasClan] = useState([]);
  const [torneoExpandidoClan, setTorneoExpandidoClan] = useState(null);
  const [guerrasPorFormato, setGuerrasPorFormato] = useState({}); // { '2v2': 3, '3v3': 1 }

  // Prodes del clan
  const [prodesClan, setProdesClan]         = useState([]);
  const [mostrarCrearProde, setMostrarCrearProde] = useState(false);
  const [prodeNombre, setProdeNombre]       = useState('');
  const [creandoProde, setCreandoProde]     = useState(false);

  const cargarTorneosClan = async (clanId) => {
    const { data } = await supabase.from('torneos')
      .select('id, nombre, tipo, created_at, torneo_participantes(user_id)')
      .eq('clan_id', clanId)
      .order('created_at', { ascending: false });
    setTorneosClan(data || []);
  };

  const cargarProdesClan = async (clanId) => {
    const { data } = await supabase.from('prode_torneos')
      .select('id, nombre, codigo_invitacion, created_at')
      .eq('clan_id', clanId)
      .order('created_at', { ascending: false });
    setProdesClan(data || []);
  };

  const crearProdeClan = async () => {
    if (!prodeNombre.trim()) return;
    setCreandoProde(true);
    const cod = Math.random().toString(36).substring(2, 8).toUpperCase();
    const { data: t } = await supabase.from('prode_torneos').insert({
      nombre: prodeNombre.trim(),
      creador_id: session.user.id,
      clan_id: miClan?.id,
      codigo_invitacion: cod,
      puntos_resultado_exacto: 5,
      puntos_resultado_parcial: 2,
      puntos_diferencia: 3,
    }).select().single();
    if (t) {
      // Unirse automáticamente como creador
      const { data: perfil } = await supabase.from('perfiles').select('nickname').eq('id', session.user.id).single();
      await supabase.from('prode_participantes').insert({ torneo_id: t.id, user_id: session.user.id, nombre_usuario: perfil?.nickname || 'Sin nick' });
    }
    setProdeNombre(''); setMostrarCrearProde(false); setCreandoProde(false);
    cargarProdesClan(miClan?.id);
  };

  const unirseAProdeClan = async (torneoId) => {
    const { data: perfil } = await supabase.from('perfiles').select('nickname').eq('id', session.user.id).single();
    const { error } = await supabase.from('prode_participantes').insert({
      torneo_id: torneoId, user_id: session.user.id, nombre_usuario: perfil?.nickname || 'Sin nick'
    });
    if (!error) cargarProdesClan(miClan?.id);
  };

  const cargarHistorialClan = async (clanId, miembrosIds) => {
    if (!miembrosIds?.length) return;
    const { data: torneos } = await supabase.from('torneos').select('id, nombre, tipo').eq('clan_id', clanId);
    if (!torneos?.length) { setHistoriaFechasClan([]); return; }

    const torneoIds = torneos.map(t => t.id);
    const { data: puntos } = await supabase
      .from('torneo_puntos')
      .select('user_id, puntos, presupuesto_gastado, torneo_id, fecha_id, fecha:torneo_fechas(numero_fecha, cerrada)')
      .in('torneo_id', torneoIds)
      .in('user_id', miembrosIds);

    // Ganador por fecha
    const fechaIds = [...new Set((puntos || []).map(pt => pt.fecha_id))];
    const ganadorPorFecha = {};
    fechaIds.forEach(fid => {
      const enFecha = (puntos || []).filter(pt => pt.fecha_id === fid);
      const mejor = enFecha.reduce((acc, pt) => {
        if (!acc) return pt;
        if (pt.puntos > acc.puntos) return pt;
        if (pt.puntos === acc.puntos && (pt.presupuesto_gastado || 0) < (acc.presupuesto_gastado || 0)) return pt;
        return acc;
      }, null);
      if (mejor?.puntos > 0) ganadorPorFecha[fid] = mejor.user_id;
    });

    // Agrupar por torneo
    const porTorneo = {};
    torneos.forEach(t => { porTorneo[t.id] = { ...t, fechas: {} }; });
    (puntos || []).forEach(pt => {
      if (!porTorneo[pt.torneo_id]) return;
      const fid = pt.fecha_id;
      if (!porTorneo[pt.torneo_id].fechas[fid]) {
        porTorneo[pt.torneo_id].fechas[fid] = {
          numero_fecha: pt.fecha?.numero_fecha,
          cerrada: pt.fecha?.cerrada,
          ganador: ganadorPorFecha[fid] || null,
          jugadores: [],
        };
      }
      porTorneo[pt.torneo_id].fechas[fid].jugadores.push({ user_id: pt.user_id, puntos: pt.puntos || 0 });
    });

    setHistoriaFechasClan(Object.values(porTorneo).map(t => ({
      ...t,
      fechas: Object.values(t.fechas).sort((a, b) => (b.numero_fecha || 0) - (a.numero_fecha || 0)),
    })));
  };

  const crearTorneoClan = async () => {
    if (!torneoNombre.trim()) return;
    // Validar equipo confirmado para torneos tácticos
    if (torneoTipo === 'tactico') {
      const { data: ventana } = await supabase.from('ventana_transferencias').select('numero_fecha').eq('activa', true).order('numero_fecha', { ascending: false }).limit(1).maybeSingle();
      if (ventana) {
        const { data: draft } = await supabase.from('drafts').select('confirmado').eq('user_id', session.user.id).eq('jornada', ventana.numero_fecha).maybeSingle();
        if (!draft?.confirmado) {
          setMsg('⚠️ Para crear un torneo táctico necesitás confirmar tu equipo primero.');
          return;
        }
      }
    }
    setMsg('');
    setCreandoTorneo(true);
    const cod = Math.random().toString(36).substring(2, 8).toUpperCase();
    const { data: t } = await supabase.from('torneos').insert({
      nombre: torneoNombre.trim(),
      tipo: torneoTipo,
      creador_id: session.user.id,
      clan_id: miClan?.id,
      codigo_invitacion: cod,
    }).select().single();
    if (t) {
      // Crear fechas automáticamente (5 fechas, fecha 1 activa)
      const fechas = Array.from({ length: 5 }, (_, i) => ({ 
        torneo_id: t.id, 
        numero_fecha: i + 1, 
        cerrada: false,
        activa: i === 0  // fecha 1 activa por defecto
      }));
      await supabase.from('torneo_fechas').insert(fechas);
      // Crear casilleros por defecto
      const casilleros = [
        { casillero: 3,  tipo: 'comodin_aleatorio',  descripcion: '¡Comodín sorpresa!',        emoji: '🎲', casilleros_efecto: 0, monto_efecto: 0 },
        { casillero: 5,  tipo: 'trampa_retroceso',   descripcion: 'Retrocedé 3 casilleros',     emoji: '⬇️', casilleros_efecto: 3, monto_efecto: 0 },
        { casillero: 7,  tipo: 'bonus_avance',        descripcion: 'Avanzá 2 casilleros',        emoji: '⬆️', casilleros_efecto: 2, monto_efecto: 0 },
        { casillero: 9,  tipo: 'trampa_retroceso',   descripcion: 'Retrocedé 2 casilleros',     emoji: '⬇️', casilleros_efecto: 2, monto_efecto: 0 },
        { casillero: 11, tipo: 'comodin_aleatorio',  descripcion: '¡Comodín sorpresa!',        emoji: '🎲', casilleros_efecto: 0, monto_efecto: 0 },
        { casillero: 13, tipo: 'trampa_retroceso',   descripcion: 'Retrocedé 3 casilleros',     emoji: '⬇️', casilleros_efecto: 3, monto_efecto: 0 },
        { casillero: 15, tipo: 'trampa_combo',        descripcion: 'Retrocedé 2 y perdés $2M',   emoji: '💸', casilleros_efecto: 2, monto_efecto: 2000000 },
        { casillero: 17, tipo: 'comodin_aleatorio',  descripcion: '¡Comodín sorpresa!',        emoji: '🎲', casilleros_efecto: 0, monto_efecto: 0 },
        { casillero: 20, tipo: 'trampa_pierde_turno',descripcion: 'Perdés el turno esta fecha', emoji: '🚫', casilleros_efecto: 0, monto_efecto: 0 },
        { casillero: 21, tipo: 'trampa_retroceso',   descripcion: 'Retrocedé 3 casilleros',     emoji: '⬇️', casilleros_efecto: 3, monto_efecto: 0 },
        { casillero: 23, tipo: 'comodin_aleatorio',  descripcion: '¡Comodín sorpresa!',        emoji: '🎲', casilleros_efecto: 0, monto_efecto: 0 },
        { casillero: 25, tipo: 'bonus_avance',        descripcion: 'Avanzá 2 casilleros',        emoji: '⬆️', casilleros_efecto: 2, monto_efecto: 0 },
      ].map(c => ({ ...c, torneo_id: t.id }));
      await supabase.from('casillero_config').insert(casilleros);
      // Unirse automáticamente con nickname real
      const nick = miembros.find(m => m.user_id === session.user.id)?.perfiles?.nickname || session.user.email?.split('@')[0] || 'Sin nick';
      await supabase.from('torneo_participantes').insert({ torneo_id: t.id, user_id: session.user.id, nombre_usuario: nick });
    }
    setTorneoNombre(''); setMostrarCrearTorneo(false); setCreandoTorneo(false);
    cargarTorneosClan(miClan?.id);
  };

  const [confirmarAccion, setConfirmarAccion] = useState(null); // { texto, onConfirm }

  const unirseATorneoClan = async (torneo) => {
    const nick = miembros.find(m => m.user_id === session.user.id)?.perfiles?.nickname || session.user.email?.split('@')[0] || 'Sin nick';

    if (torneo.tipo === 'tactico') {
      const { data: ventana } = await supabase.from('ventana_transferencias')
        .select('numero_fecha').eq('activa', true).order('numero_fecha', { ascending: false }).limit(1).maybeSingle();
      const { data: draft } = await supabase.from('drafts')
        .select('confirmado').eq('user_id', session.user.id).eq('jornada', ventana?.numero_fecha || 1).maybeSingle();

      if (!draft) {
        setConfirmarAccion({
          texto: 'Necesitás crear tu equipo táctico primero. ¿Ir a armarlo ahora?',
          onConfirm: () => navigate('/equipo-tactico'),
        });
        return;
      }
      if (!draft.confirmado) {
        setConfirmarAccion({
          texto: 'Necesitás confirmar tu equipo táctico primero. ¿Ir a confirmarlo ahora?',
          onConfirm: () => navigate('/equipo-tactico'),
        });
        return;
      }
    }

    const { error } = await supabase.from('torneo_participantes').insert({ torneo_id: torneo.id, user_id: session.user.id, nombre_usuario: nick });
    if (!error) cargarTorneosClan(miClan?.id);
    else if (error.code === '23505') setMsg('Ya estás inscripto en este torneo');
    else setMsg('Error al unirse al torneo');
  };

  const abrirEdicion = () => {
    setFormNombre(miClan?.nombre);
    setFormTag(miClan?.tag);
    setFormDesc(miClan?.descripcion || '');
    setFormEmblema(miClan?.emblema || 'escudo_1');
    setFormColor(miClan?.color||'#00f2ff' || '#00f2ff');
    setFormTipo(miClan?.tipo || 'abierto');
    setMsg('');
    setVista('editar');
  };

  const guardarEdicion = async () => {
    if (!formNombre.trim() || !formTag.trim()) { setMsg('Nombre y tag son obligatorios'); return; }
    setGuardandoEdicion(true); setMsg('');
    const { error } = await supabase.from('clanes').update({
      nombre: formNombre.trim(),
      tag: formTag.trim().toUpperCase(),
      descripcion: formDesc.trim(),
      emblema: formEmblema,
      color: formColor,
      tipo: formTipo,
    }).eq('id', miClan?.id);
    setGuardandoEdicion(false);
    if (error) { setMsg(error.message.includes('unique') ? 'Ese nombre o tag ya existe' : error.message); return; }
    cargarMiClan();
  };

  useEffect(() => { cargarMiClan(); }, [session.user.id]);

  const cargarMiClan = async () => {
    const { data: membresia } = await supabase
      .from('clan_miembros').select('clan_id, rol').eq('user_id', session.user.id).maybeSingle();

    const { data: perfil } = await supabase
      .from('perfiles').select('puntos_ranked, rango_ranked, victorias_ranked, derrotas_ranked, empates_ranked, racha_ranked, mejor_rango, nickname')
      .eq('id', session.user.id).single();
    setPerfilRanked(perfil);

    if (!membresia) { setVista('sin_clan'); return; }

    const { data: clan } = await supabase.from('clanes').select('*').eq('id', membresia.clan_id).single();

    // Dos queries separadas para evitar problemas de FK con join embebido
    const { data: mbs } = await supabase
      .from('clan_miembros')
      .select('user_id, rol, joined_at, medallas')
      .eq('clan_id', membresia.clan_id)
      .order('joined_at');

    // Traer perfiles de los miembros
    const userIds = (mbs || []).map(m => m.user_id);
    let perfilesMap = {};
    if (userIds.length > 0) {
      const { data: perfs } = await supabase
        .from('perfiles')
        .select('id, nickname, puntos_ranked, rango_ranked')
        .in('id', userIds);
      (perfs || []).forEach(p => { perfilesMap[p.id] = p; });
    }

    const mbsConPerfil = (mbs || []).map(m => ({ ...m, perfiles: perfilesMap[m.user_id] || {} }));

    // Cargar todo en paralelo antes de mostrar para evitar flash
    const [
      { data: torneosData },
      { data: prodesData },
      { data: guerrasGanadasData },
    ] = await Promise.all([
      supabase.from('torneos').select('id, nombre, tipo, created_at, torneo_participantes(user_id)').eq('clan_id', membresia.clan_id).order('created_at', { ascending: false }),
      supabase.from('prode_torneos').select('id, nombre, codigo_invitacion, created_at').eq('clan_id', membresia.clan_id).order('created_at', { ascending: false }),
      supabase.from('clan_guerras').select('formato').eq('ganador_clan_id', membresia.clan_id).eq('estado', 'finalizada'),
    ]);

    const porFormato = {};
    (guerrasGanadasData || []).forEach(g => { porFormato[g.formato] = (porFormato[g.formato] || 0) + 1; });

    // Setear todo junto antes de mostrar
    setMiClan({ ...clan, miRol: membresia.rol });
    setMiembros(mbsConPerfil);
    setTorneosClan(torneosData || []);
    setProdesClan(prodesData || []);
    setGuerrasPorFormato(porFormato);
    setVista('mi_clan');

    // Historial es más pesado, lo cargamos después sin bloquear
    cargarHistorialClan(membresia.clan_id, userIds);
  };



  const crearClan = async () => {
    if (!formNombre.trim() || !formTag.trim()) { setMsg('Nombre y tag son obligatorios'); return; }
    if (formTag.length > 4) { setMsg('El tag no puede tener más de 4 letras'); return; }
    setCreando(true); setMsg('');
    const codigo = Math.random().toString(36).substring(2, 8).toUpperCase();
    const { data: clan, error } = await supabase.from('clanes').insert({
      nombre: formNombre.trim(),
      tag: formTag.trim().toUpperCase(),
      descripcion: formDesc.trim(),
      emblema: formEmblema,
      color: formColor,
      tipo: formTipo,
      codigo_invitacion: codigo,
      lider_id: session.user.id,
    }).select().single();

    if (error) { setMsg(error.message.includes('unique') ? 'Ese nombre o tag ya existe' : error.message); setCreando(false); return; }

    await supabase.from('clan_miembros').insert({ clan_id: clan.id, user_id: session.user.id, rol: 'lider' });
    setCreando(false);
    cargarMiClan();
  };

  const unirseAClanDirecto = async (clanId) => {
    setUniendose(true); setMsg('');
    const { error } = await supabase.from('clan_miembros').insert({ clan_id: clanId, user_id: session.user.id, rol: 'miembro' });
    if (error?.message?.includes('unique')) { setMsg('Ya pertenecés a un clan.'); }
    else if (error) { setMsg('Error al unirse'); }
    else { setUniendose(false); cargarMiClan(); return; }
    setUniendose(false);
  };

  const unirseAClan = async () => {
    if (!codigoUnirse.trim()) return;
    setUniendose(true); setMsg('');
    const { data: clan } = await supabase.from('clanes').select('id, nombre, tipo').eq('codigo_invitacion', codigoUnirse.toUpperCase()).single();
    if (!clan) { setMsg('Código inválido'); setUniendose(false); return; }
    const { error } = await supabase.from('clan_miembros').insert({ clan_id: clan.id, user_id: session.user.id, rol: 'miembro' });
    if (error?.code === '23505') { setMsg('Ya estás en este clan'); }
    else if (error?.code === '23503') { setMsg('Error al unirse'); }
    else if (error?.message?.includes('unique')) { setMsg('Ya pertenecés a un clan. Salí del clan actual primero.'); }
    else { setUniendose(false); cargarMiClan(); return; }
    setUniendose(false);
  };

  const salirDelClan = async () => {
    if (!window.confirm('¿Seguro que querés salir del clan?')) return;
    await supabase.from('clan_miembros').delete().eq('user_id', session.user.id);
    setMiClan(null); setMiembros([]); setVista('sin_clan');
  };

  const eliminarClan = async () => {
    if (!window.confirm('¿Seguro que querés ELIMINAR el clan? Esta acción no se puede deshacer.')) return;
    if (!window.confirm('Última confirmación — se eliminarán todos los datos del clan.')) return;
    await supabase.from('clanes').delete().eq('id', miClan?.id);
    setMiClan(null); setMiembros([]); setVista('sin_clan');
  };

  const cambiarRol = async (userId, nuevoRol) => {
    await supabase.from('clan_miembros').update({ rol: nuevoRol }).eq('user_id', userId).eq('clan_id', miClan?.id);
    cargarMiClan();
  };

  const expulsarMiembro = async (userId) => {
    if (!window.confirm('¿Expulsar a este miembro?')) return;
    await supabase.from('clan_miembros').delete().eq('user_id', userId);
    cargarMiClan();
  };

  // ── ESTILOS BASE ─────────────────────────────────────────────────────────────
  const S = {
    page:    { padding: '24px 28px', color: 'white', minHeight: 'calc(100vh - var(--navbar-h))', background: '#020b18' },
    card:    { background: '#080d14', border: '1px solid #1e293b', borderRadius: '12px', padding: '20px' },
    btn:     (color='#00f2ff') => ({ background: `${color}22`, border: `1px solid ${color}`, borderRadius: '8px', padding: '9px 20px', color, fontWeight: 'bold', fontSize: '0.82rem', cursor: 'pointer', transition: '0.2s' }),
    input:   { background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '6px', padding: '9px 12px', color: '#fff', fontSize: '0.85rem', width: '100%', boxSizing: 'border-box' },
    label:   { color: '#475569', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '5px', display: 'block' },
    section: { marginBottom: '24px' },
  };

  // ── LOADING ──────────────────────────────────────────────────────────────────
  if (vista === 'loading') return <Loader texto="Cargando club..." />;

  // ── SIN CLAN ─────────────────────────────────────────────────────────────────
  if (vista === 'sin_clan' || vista === 'crear' || vista === 'buscar' || vista === 'explorar') return (
    <div style={{ ...S.page, maxWidth: '600px', margin: '0 auto' }}>
      <h1 style={{ margin: '0 0 6px', fontSize: '1.5rem' }}>Clubes</h1>
      <p style={{ color: '#475569', margin: '0 0 28px', fontSize: '0.85rem' }}>No pertenecés a ningún club todavía</p>



      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '24px' }}>
        <button onClick={() => setVista('crear')} style={{ ...S.card, border: `1px solid ${vista === 'crear' ? '#00f2ff' : '#1e293b'}`, cursor: 'pointer', textAlign: 'left', transition: '0.2s' }}>
          <p style={{ margin: '0 0 4px', fontSize: '1.2rem' }}></p>
          <p style={{ margin: '0 0 4px', color: '#e2e8f0', fontWeight: 'bold', fontSize: '0.9rem' }}>Crear Club</p>
          <p style={{ margin: 0, color: '#475569', fontSize: '0.88rem' }}>Fundá tu propio club</p>
        </button>
        <button onClick={() => setVista('buscar')} style={{ ...S.card, border: `1px solid ${vista === 'buscar' ? '#00f2ff' : '#1e293b'}`, cursor: 'pointer', textAlign: 'left', transition: '0.2s' }}>
          <p style={{ margin: '0 0 4px', fontSize: '1.2rem' }}></p>
          <p style={{ margin: '0 0 4px', color: '#e2e8f0', fontWeight: 'bold', fontSize: '0.9rem' }}>Unirse con código</p>
          <p style={{ margin: 0, color: '#475569', fontSize: '0.88rem' }}>Ingresá el código</p>
        </button>
        <button onClick={async () => { setVista('explorar'); if (!clanList.length) { const { data } = await supabase.from('clanes').select('id, nombre, tag, emblema, color, tipo, descripcion, medallas, guerras_ganadas, puntos_clan').order('puntos_clan', { ascending: false }).limit(50);
                  // Get member counts
                  if (data?.length) {
                    const counts = await Promise.all(data.map(c => supabase.from('clan_miembros').select('clan_id', { count: 'exact', head: true }).eq('clan_id', c.id)));
                    const withCounts = data.map((c, i) => ({ ...c, miembros_count: counts[i].count || 0 }));
                    setClanList(withCounts);
                  } else setClanList([]); }}}
          style={{ ...S.card, border: `1px solid ${vista === 'explorar' ? '#00f2ff' : '#1e293b'}`, cursor: 'pointer', textAlign: 'left', transition: '0.2s' }}>
          <p style={{ margin: '0 0 4px', fontSize: '1.2rem' }}></p>
          <p style={{ margin: '0 0 4px', color: '#e2e8f0', fontWeight: 'bold', fontSize: '0.9rem' }}>Explorar clubes</p>
          <p style={{ margin: 0, color: '#475569', fontSize: '0.88rem' }}>Ver clubes abiertos</p>
        </button>
      </div>

      {/* FORMULARIO CREAR */}
      {vista === 'crear' && (
        <div style={S.card}>
          <h3 style={{ margin: '0 0 20px', color: '#00f2ff', fontSize: '1rem' }}>Nuevo Club</h3>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '12px', marginBottom: '12px' }}>
            <div>
              <label style={S.label}>Nombre del club</label>
              <input style={S.input} placeholder="Los Cracks del Barrio" value={formNombre} onChange={e => setFormNombre(e.target.value)} maxLength={40} />
            </div>
            <div>
              <label style={S.label}>Tag (máx 4)</label>
              <input style={{ ...S.input, width: '80px', textTransform: 'uppercase', letterSpacing: '2px', fontWeight: 'bold' }}
                placeholder="LCB" value={formTag} onChange={e => setFormTag(e.target.value.slice(0,4))} maxLength={4} />
            </div>
          </div>

          <div style={{ marginBottom: '12px' }}>
            <label style={S.label}>Descripción (opcional)</label>
            <input style={S.input} placeholder="Breve descripción del club..." value={formDesc} onChange={e => setFormDesc(e.target.value)} maxLength={120} />
          </div>

          {/* Emblema */}
          <div style={{ marginBottom: '12px' }}>
            <label style={S.label}>Emblema</label>
            <p style={{ color: '#334155', fontSize: '0.78rem', margin: '-2px 0 8px' }}>Más emblemas se desbloquean ganando guerras 🏅</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
              {['escudo_1','escudo_2','estrella','fuego'].map(key => (
                <button key={key} onClick={() => setFormEmblema(key)} style={{
                  width: '40px', height: '40px', fontSize: '1.3rem', borderRadius: '8px', cursor: 'pointer',
                  border: `2px solid ${formEmblema === key ? formColor : '#1e293b'}`,
                  background: formEmblema === key ? `${formColor}22` : '#0a0f19',
                  transition: '0.15s',
                }}>{EMBLEMAS[key]}</button>
              ))}
            </div>
          </div>

          {/* Color */}
          <div style={{ marginBottom: '16px' }}>
            <label style={S.label}>Color del club</label>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {COLORES.map(c => (
                <button key={c} onClick={() => setFormColor(c)} style={{
                  width: '28px', height: '28px', borderRadius: '50%', background: c, cursor: 'pointer',
                  border: `3px solid ${formColor === c ? '#fff' : 'transparent'}`, transition: '0.15s',
                }} />
              ))}
            </div>
          </div>

          {/* Preview */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', background: '#0a0f19', borderRadius: '8px', border: `1px solid ${formColor}44`, marginBottom: '16px' }}>
            <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: `${formColor}22`, border: `2px solid ${formColor}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.6rem' }}>
              {EMBLEMAS[formEmblema]}
            </div>
            <div>
              <p style={{ margin: 0, color: formColor, fontWeight: 'bold', fontSize: '1rem' }}>{formNombre || 'Nombre del club'}</p>
              <p style={{ margin: 0, color: '#475569', fontSize: '0.88rem' }}>[{formTag || 'TAG'}] • 1 miembro</p>
            </div>
          </div>

          {msg && <p style={{ color: '#ef4444', fontSize: '0.8rem', margin: '0 0 12px' }}>{msg}</p>}
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={crearClan} disabled={creando} style={{ ...S.btn(formColor), flex: 1, opacity: creando ? 0.6 : 1 }}>
              {creando ? 'Creando...' : ' Crear Club'}
            </button>
            <button onClick={() => { setVista('sin_clan'); setMsg(''); }} style={S.btn('#94a3b8')}>Cancelar</button>
          </div>
        </div>
      )}

      {/* FORMULARIO UNIRSE */}
      {vista === 'buscar' && (
        <div style={S.card}>
          <h3 style={{ margin: '0 0 16px', color: '#00f2ff', fontSize: '1rem' }}>Unirse con código</h3>
          <label style={S.label}>Código de invitación</label>
          <input style={{ ...S.input, textTransform: 'uppercase', letterSpacing: '3px', fontWeight: 'bold', fontSize: '1rem', marginBottom: '12px' }}
            placeholder="XXXXXX" value={codigoUnirse} onChange={e => setCodigoUnirse(e.target.value.slice(0,6))} maxLength={6} />
          {msg && <p style={{ color: '#ef4444', fontSize: '0.8rem', margin: '0 0 12px' }}>{msg}</p>}
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={unirseAClan} disabled={uniendose || codigoUnirse.length < 4} style={{ ...S.btn('#00f2ff'), flex: 1, opacity: (uniendose || codigoUnirse.length < 4) ? 0.5 : 1 }}>
              {uniendose ? 'Buscando...' : 'Unirse'}
            </button>
            <button onClick={() => { setVista('sin_clan'); setMsg(''); }} style={S.btn('#94a3b8')}>Cancelar</button>
          </div>
        </div>
      )}

      {/* EXPLORAR CLANES */}
      {vista === 'explorar' && (
        <div style={S.card}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <h3 style={{ margin: 0, color: '#00f2ff', fontSize: '1rem' }}>Clubes</h3>
            <span style={{ color: '#475569', fontSize: '0.85rem' }}>{clanList.length} clubes</span>
          </div>
          <div className="clan-miembros-grid" style={{ display: 'grid', gridTemplateColumns: '28px 1fr 58px 44px 44px 54px 30px', gap: '4px', padding: '5px 10px', borderBottom: '1px solid #1e293b', marginBottom: '4px' }}>
            {['', 'CLUB', 'MB', '🏅', 'GG', 'PTS', ''].map((h, i) => (
              <span key={i} className={i >= 2 && i <= 4 ? 'clan-col-hide' : ''} style={{ color: '#334155', fontSize: '0.58rem', textTransform: 'uppercase', letterSpacing: '1px', textAlign: i >= 2 ? 'center' : 'left' }}>{h}</span>
            ))}
          </div>
          {clanList.length === 0
            ? <p style={{ color: '#475569', textAlign: 'center', padding: '20px 0' }}>Cargando...</p>
            : <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
                {[...clanList].sort((a,b) => (b.puntos_clan||0) - (a.puntos_clan||0)).map((c, idx) => {
                  const color = c.color || '#00f2ff';
                  const abierto = c.tipo === 'abierto';
                  return (
                    <div key={c.id} className="clan-miembros-grid" style={{ display: 'grid', gridTemplateColumns: '28px 1fr 58px 44px 44px 54px 30px', gap: '4px', padding: '8px 10px', borderRadius: '7px', background: idx % 2 === 0 ? '#050b14' : 'transparent', alignItems: 'center' }}>
                      <span style={{ fontSize: '1rem', textAlign: 'center' }}>{EMBLEMAS[c.emblema] || ''}</span>
                      <div style={{ minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <span style={{ color, fontWeight: 'bold', fontSize: '0.8rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.nombre}</span>
                          <span style={{ color: '#334155', fontSize: '0.6rem', flexShrink: 0 }}>[{c.tag}]</span>
                        </div>
                        {c.descripcion && <p style={{ margin: 0, color: '#334155', fontSize: '0.6rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.descripcion}</p>}
                      </div>
                      <span className="clan-col-hide" style={{ color: '#64748b', fontSize: '0.85rem', textAlign: 'center' }}>{c.miembros_count || 0}/15</span>
                      <span className="clan-col-hide" style={{ color: '#f59e0b', fontSize: '0.85rem', textAlign: 'center', fontWeight: 'bold' }}>{c.medallas || 0}</span>
                      <span className="clan-col-hide" style={{ color: '#22c55e', fontSize: '0.85rem', textAlign: 'center' }}>{c.guerras_ganadas || 0}</span>
                      <span style={{ color, fontSize: '0.85rem', textAlign: 'center', fontWeight: 'bold' }}>{c.puntos_clan || 0}</span>
                      {abierto
                        ? <button onClick={() => unirseAClanDirecto(c.id)} style={{ background: `${color}22`, border: `1px solid ${color}`, borderRadius: '5px', color, fontSize: '0.8rem', fontWeight: 'bold', cursor: 'pointer', padding: '2px 0', width: '100%' }}>+</button>
                        : <span style={{ textAlign: 'center', fontSize: '0.8rem' }}></span>
                      }
                    </div>
                  );
                })}
              </div>
          }
          {msg && <p style={{ color: '#ef4444', fontSize: '0.8rem', margin: '8px 0 0' }}>{msg}</p>}
          <button onClick={() => { setVista('sin_clan'); setMsg(''); }} style={{ ...S.btn('#94a3b8'), marginTop: '12px', width: '100%' }}>Volver</button>
        </div>
      )}
    </div>
  );

  // ── MI CLAN ──────────────────────────────────────────────────────────────────
  const esLider   = miClan?.miRol === 'lider';
  const esColider = miClan?.miRol === 'colider';

  // ── VISTA EDITAR ─────────────────────────────────────────────────────────────
  if (vista === 'editar') return (
    <div style={{ ...S.page, maxWidth: '600px', margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
        <button onClick={() => { setVista('mi_clan'); setMsg(''); }} style={{ background: 'none', border: 'none', color: '#475569', cursor: 'pointer', fontSize: '1.2rem' }}>←</button>
        <h1 style={{ margin: 0, fontSize: '1.3rem' }}>✏️ Editar Clan</h1>
      </div>
      <div style={S.card}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '12px', marginBottom: '12px' }}>
          <div>
            <label style={S.label}>Nombre del clan</label>
            <input style={S.input} value={formNombre} onChange={e => setFormNombre(e.target.value)} maxLength={40} />
          </div>
          <div>
            <label style={S.label}>Tag (máx 4)</label>
            <input style={{ ...S.input, width: '80px', textTransform: 'uppercase', letterSpacing: '2px', fontWeight: 'bold' }}
              value={formTag} onChange={e => setFormTag(e.target.value.slice(0,4))} maxLength={4} />
          </div>
        </div>
        <div style={{ marginBottom: '12px' }}>
          <label style={S.label}>Descripción</label>
          <input style={S.input} placeholder="Breve descripción del club..." value={formDesc} onChange={e => setFormDesc(e.target.value)} maxLength={120} />
        </div>
        <div style={{ marginBottom: '12px' }}>
          <label style={S.label}>Tipo</label>
          <div style={{ display: 'flex', gap: '8px' }}>
            {['abierto','cerrado'].map(t => (
              <button key={t} onClick={() => setFormTipo(t)} style={{ ...S.btn(formTipo === t ? '#00f2ff' : '#94a3b8'), flex: 1, opacity: formTipo === t ? 1 : 0.5 }}>
                {t === 'abierto' ? 'Abierto' : 'Cerrado'}
              </button>
            ))}
          </div>
        </div>
        <div style={{ marginBottom: '12px' }}>
          <label style={S.label}>Emblema</label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {Object.entries(EMBLEMAS).filter(([key]) => {
              const desbloqueados = ['escudo_1','escudo_2','estrella','fuego'];
              if (desbloqueados.includes(key)) return true;
              const req = { trofeo:3,rayo:3,corona:5,dragon:5,aguila:8,leon:8,diamante:12,cohete:12,lobo:20,toro:20,calavera:30,planeta:30 };
              return (miClan?.medallas || 0) >= (req[key] || 99);
            }).map(([key, emoji]) => (
              <button key={key} onClick={() => setFormEmblema(key)} style={{
                width: '40px', height: '40px', fontSize: '1.3rem', borderRadius: '8px', cursor: 'pointer',
                border: `2px solid ${formEmblema === key ? formColor : '#1e293b'}`,
                background: formEmblema === key ? `${formColor}22` : '#0a0f19', transition: '0.15s',
              }}>{emoji}</button>
            ))}
          </div>
        </div>
        <div style={{ marginBottom: '16px' }}>
          <label style={S.label}>Color del clan</label>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {COLORES.map(c => (
              <button key={c} onClick={() => setFormColor(c)} style={{
                width: '28px', height: '28px', borderRadius: '50%', background: c, cursor: 'pointer',
                border: `3px solid ${formColor === c ? '#fff' : 'transparent'}`, transition: '0.15s',
              }} />
            ))}
          </div>
        </div>
        {/* Preview */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', background: '#0a0f19', borderRadius: '8px', border: `1px solid ${formColor}44`, marginBottom: '16px' }}>
          <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: `${formColor}22`, border: `2px solid ${formColor}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.6rem' }}>
            {EMBLEMAS[formEmblema]}
          </div>
          <div>
            <p style={{ margin: 0, color: formColor, fontWeight: 'bold', fontSize: '1rem' }}>{formNombre}</p>
            <p style={{ margin: 0, color: '#475569', fontSize: '0.88rem' }}>[{formTag}] • {miembros.length} miembro{miembros.length !== 1 ? 's' : ''}</p>
          </div>
        </div>
        {msg && <p style={{ color: '#ef4444', fontSize: '0.8rem', margin: '0 0 12px' }}>{msg}</p>}
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={guardarEdicion} disabled={guardandoEdicion} style={{ ...S.btn(formColor), flex: 1, opacity: guardandoEdicion ? 0.6 : 1 }}>
            {guardandoEdicion ? 'Guardando...' : '💾 Guardar cambios'}
          </button>
          <button onClick={() => { setVista('mi_clan'); setMsg(''); }} style={S.btn('#94a3b8')}>Cancelar</button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ ...S.page, maxWidth: '800px', margin: '0 auto' }}>

      {/* Modal de confirmación inline */}
      {confirmarAccion && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#0f172a', border: '1px solid #f59e0b', borderRadius: '14px', padding: '28px 32px', maxWidth: '380px', width: '90%', textAlign: 'center' }}>
            <p style={{ fontSize: '1.4rem', margin: '0 0 12px' }}>⚠️</p>
            <p style={{ color: '#f59e0b', fontSize: '0.9rem', margin: '0 0 20px', lineHeight: 1.5 }}>{confirmarAccion.texto}</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button onClick={() => { confirmarAccion.onConfirm(); setConfirmarAccion(null); }}
                style={{ padding: '9px 22px', background: '#f59e0b22', border: '1px solid #f59e0b', borderRadius: '8px', color: '#f59e0b', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.85rem' }}>
                Ir ahora
              </button>
              <button onClick={() => setConfirmarAccion(null)}
                style={{ padding: '9px 22px', background: 'transparent', border: '1px solid #334155', borderRadius: '8px', color: '#64748b', cursor: 'pointer', fontSize: '0.85rem' }}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
      <div style={{ ...S.card, marginBottom: '20px', borderColor: `${miClan?.color||'#00f2ff'}44` }}>
        <div className="clan-header-flex" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {/* Emblema */}
          <div style={{ width: '64px', height: '64px', borderRadius: '16px', background: `${miClan?.color||'#00f2ff'}22`, border: `2px solid ${miClan?.color||'#00f2ff'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem', flexShrink: 0 }}>
            {EMBLEMAS[miClan?.emblema] || ''}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <h2 style={{ margin: 0, fontSize: '1.3rem', color: '#e2e8f0' }}>{miClan?.nombre}</h2>
              <span style={{ background: `${miClan?.color||'#00f2ff'}22`, border: `1px solid ${miClan?.color||'#00f2ff'}55`, borderRadius: '4px', padding: '1px 7px', color: miClan?.color||'#00f2ff', fontSize: '0.85rem', fontWeight: 'bold', letterSpacing: '1px' }}>[{miClan?.tag}]</span>
              <span style={{ background: miClan?.tipo === 'abierto' ? '#22c55e22' : '#f59e0b22', border: `1px solid ${miClan?.tipo === 'abierto' ? '#22c55e44' : '#f59e0b44'}`, borderRadius: '4px', padding: '1px 7px', color: miClan?.tipo === 'abierto' ? '#22c55e' : '#f59e0b', fontSize: '0.78rem' }}>
                {miClan?.tipo === 'abierto' ? 'Abierto' : 'Cerrado'}
              </span>
            </div>
            {miClan?.descripcion && <p style={{ margin: '4px 0 0', color: '#93a1b3', fontSize: '0.8rem' }}>{miClan?.descripcion}</p>}
            <p style={{ margin: '6px 0 0', color: '#94a3b8', fontSize: '0.85rem' }}>
              👥 {miembros.length}<span style={{ color: '#94a3b8' }}>/15</span>
              <span className="clan-codigo-hide"> &nbsp;•&nbsp; Código: <span style={{ color: '#94a3b8', fontWeight: 'bold', letterSpacing: '1px' }}>{miClan?.codigo_invitacion}</span></span>
            </p>
          </div>
          {/* Acciones del líder en el header */}
          {esLider && (
            <button onClick={abrirEdicion} style={{ ...S.btn(miClan?.color||'#00f2ff'), fontSize: '0.88rem', flexShrink: 0, padding: '6px 14px' }}>
              Editar
            </button>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flexShrink: 0, textAlign: 'center' }}>
            <span style={{ color: '#475569', fontSize: '0.88rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Puntos</span>
            <span style={{ color: miClan?.color||'#00f2ff', fontWeight: 'bold', fontSize: '1.4rem', lineHeight: 1 }}>{miClan?.puntos_clan || 0}</span>
            <span style={{ color: '#334155', fontSize: '0.78rem' }}>💎 {miClan?.medallas || 0} medallas</span>
          </div>
        </div>
      </div>


      {/* TABS DE CONTENIDO */}
      {(() => {
        const [tabActiva, setTabActiva] = [
          window._clanTab || 'actividad',
          (t) => { window._clanTab = t; }
        ];
        return null;
      })()}
      <ClanTabs
        miClan={miClan} miembros={miembros} session={session} esLider={esLider} esColider={esColider}
        torneosClan={torneosClan} prodesClan={prodesClan}
        mostrarCrearTorneo={mostrarCrearTorneo} setMostrarCrearTorneo={setMostrarCrearTorneo}
        torneoNombre={torneoNombre} setTorneoNombre={setTorneoNombre}
        torneoTipo={torneoTipo} setTorneoTipo={setTorneoTipo}
        creandoTorneo={creandoTorneo} crearTorneoClan={crearTorneoClan} msg={msg} setMsg={setMsg}
        mostrarCrearProde={mostrarCrearProde} setMostrarCrearProde={setMostrarCrearProde}
        prodeNombre={prodeNombre} setProdeNombre={setProdeNombre}
        creandoProde={creandoProde} crearProdeClan={crearProdeClan}
        navigate={navigate} S={S} calcularRango={calcularRango}
        cambiarRol={cambiarRol} expulsarMiembro={expulsarMiembro}
        salirDelClan={salirDelClan} eliminarClan={eliminarClan}
        historiaFechasClan={historiaFechasClan}
        torneoExpandidoClan={torneoExpandidoClan} setTorneoExpandidoClan={setTorneoExpandidoClan}
        guerrasPorFormato={guerrasPorFormato}
        unirseATorneoClan={unirseATorneoClan}
        cargarMiClan={cargarMiClan}
      />
    </div>
  );
};

// Componente de tabs separado para evitar re-renders del padre
const ClanTabs = ({
  miClan, miembros, session, esLider, esColider,
  torneosClan, prodesClan,
  mostrarCrearTorneo, setMostrarCrearTorneo, torneoNombre, setTorneoNombre,
  torneoTipo, setTorneoTipo, creandoTorneo, crearTorneoClan, msg, setMsg,
  mostrarCrearProde, setMostrarCrearProde, prodeNombre, setProdeNombre,
  creandoProde, crearProdeClan,
  navigate, S, calcularRango, cambiarRol, expulsarMiembro, salirDelClan, eliminarClan,
  historiaFechasClan, torneoExpandidoClan, setTorneoExpandidoClan,
  guerrasPorFormato, unirseATorneoClan, cargarMiClan
}) => {
  const [tab, setTab] = React.useState('actividad');
  React.useEffect(() => { if (tab === 'actividad' && cargarMiClan) cargarMiClan(); }, [tab]); // eslint-disable-line
  // Guerras
  const [guerras, setGuerras] = React.useState([]);
  const [guerrasRival, setGuerrasRival] = React.useState([]);
  const [todosClanes, setTodosClanes] = React.useState([]);
  const [vistaGuerra, setVistaGuerra] = React.useState('lista'); // lista | retar | guerreros
  const [guerraActiva, setGuerraActiva] = React.useState(null);
  const [clanRetadoId, setClanRetadoId] = React.useState('');
  const [guerrerosElegidos, setGuerrerosElegidos] = React.useState([]);
  const [enviandoGuerra, setEnviandoGuerra] = React.useState(false);
  const [formatoGuerra, setFormatoGuerra] = React.useState('5v5');
  // Retos
  const [retos, setRetos] = React.useState([]);
  const [vistaReto, setVistaReto] = React.useState(null); // null | 'crear'
  const [formatoReto, setFormatoReto] = React.useState('2v2');
  const [modoReto, setModoReto] = React.useState('tactico');
  const [miembrosReto, setMiembrosReto] = React.useState([]);
  const [enviandoReto, setEnviandoReto] = React.useState(false);
  const [retoDetalle, setRetoDetalle] = React.useState(null);
  const [rivalesNicks, setRivalesNicks] = React.useState({});
  const [puntosGuerra, setPuntosGuerra] = React.useState({}); // { user_id: pts }

  const FORMATOS = {
    '2v2': { label: '2v2', guerreros: 2, pts: 25 },
    '3v3': { label: '3v3', guerreros: 3, pts: 35 },
    '5v5': { label: '5v5', guerreros: 5, pts: 60 },
    '7v7': { label: '7v7', guerreros: 7, pts: 80 },
    '11v11': { label: '11v11', guerreros: 11, pts: 100 },
  };
  // Chat
  const [mensajes, setMensajes] = React.useState([]);
  const [nuevoMsg, setNuevoMsg] = React.useState('');
  const [enviandoMsg, setEnviandoMsg] = React.useState(false);
  const [miNick, setMiNick] = React.useState('');
  const [mensajesNoLeidos, setMensajesNoLeidos] = React.useState(0);
  const chatRef = React.useRef(null);
  const tabRef = React.useRef(tab);
  const ultimoMsgRef = React.useRef(0);
  const [cooldownActivo, setCooldownActivo] = React.useState(false);
  const [mensajeFijado, setMensajeFijado] = React.useState(miClan?.mensaje_fijado || '');
  const [editandoFijado, setEditandoFijado] = React.useState(false);
  const [tempFijado, setTempFijado] = React.useState('');
  React.useEffect(() => { tabRef.current = tab; }, [tab]);

  // Cargar guerras del clan
  const cargarGuerras = React.useCallback(async () => {
    if (!miClan?.id) return;
    const { data } = await supabase.from('clan_guerras')
      .select('*')
      .or(`clan_retador_id.eq.${miClan.id},clan_retado_id.eq.${miClan.id}`)
      .order('created_at', { ascending: false });
    setGuerras(data || []);
  }, [miClan?.id]);

  // Cargar retos del clan
  const cargarRetos = React.useCallback(async () => {
    const { data } = await supabase.from('clan_retos_espera')
      .select('*').eq('clan_id', miClan?.id)
      .order('created_at', { ascending: false });
    setRetos(data || []);
  }, [miClan?.id]);

  const crearReto = async () => {
    const cantMin = parseInt(formatoReto.split('v')[0]);
    if (miembrosReto.length < cantMin) return;
    // Validar máx 3 retos activos por persona
    const retosActivos = retos.filter(r => ['pendiente_aprobacion','buscando'].includes(r.estado));
    for (const uid of miembrosReto) {
      const retosUsr = retosActivos.filter(r => r.miembros?.includes(uid)).length;
      if (retosUsr >= 3) {
        const nick = miembros.find(m => m.user_id === uid)?.perfiles?.nickname || uid;
        alert(`${nick} ya tiene 3 retos activos (máximo permitido)`);
        return;
      }
    }
    setEnviandoReto(true);
    await supabase.from('clan_retos_espera').insert({
      clan_id: miClan?.id,
      formato: formatoReto,
      modo: modoReto,
      miembros: miembrosReto,
      creador_id: session.user.id,
      estado: 'pendiente_aprobacion',
    });
    setEnviandoReto(false);
    setVistaReto(null);
    setMiembrosReto([]);
    cargarRetos();
  };

  const aprobarReto = async (retoId, aprobar) => {
    if (aprobar) {
      await supabase.from('clan_retos_espera').update({ estado: 'buscando' }).eq('id', retoId);
    } else {
      await supabase.from('clan_retos_espera').update({ estado: 'expirado' }).eq('id', retoId);
    }
    cargarRetos();
  };

  // Cargar todos los clanes para retar
  const cargarTodosClanes = React.useCallback(async () => {
    const { data } = await supabase.from('clanes').select('id, nombre, tag, emblema, color, medallas, guerras_ganadas, guerras_jugadas')
      .neq('id', miClan?.id);
    setTodosClanes(data || []);
  }, [miClan?.id]);

  // Cargar chat
  const cargarChat = React.useCallback(async () => {
    const { data } = await supabase.from('clan_chat')
      .select('*').eq('clan_id', miClan?.id)
      .order('created_at', { ascending: true }).limit(50);
    setMensajes(data || []);
    setTimeout(() => { chatRef.current?.scrollTo(0, chatRef.current.scrollHeight); }, 50);
  }, [miClan?.id]);

  // Nick — cargar una vez
  React.useEffect(() => {
    supabase.from('perfiles').select('nickname').eq('id', session.user.id).single()
      .then(({ data }) => setMiNick(data?.nickname || ''));
  }, [session.user.id]);

  // Realtime chat — siempre suscrito, badge si no estás en la tab
  React.useEffect(() => {
    const canal = supabase.channel('clan_chat_' + miClan?.id)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'clan_chat', filter: `clan_id=eq.${miClan?.id}` },
        (payload) => {
          if (tabRef.current === 'chat') {
            // Siempre recargar si estás en la tab — incluye tus propios mensajes
            setMensajes(prev => {
              // Evitar duplicados
              if (prev.some(m => m.id === payload.new.id)) return prev;
              const nuevo = [...prev, payload.new];
              setTimeout(() => { chatRef.current?.scrollTo(0, chatRef.current.scrollHeight); }, 30);
              return nuevo;
            });
          } else if (payload.new?.user_id !== session.user.id) {
            setMensajesNoLeidos(prev => prev + 1);
          }
        })
      .subscribe();
    return () => supabase.removeChannel(canal);
  }, [miClan?.id, session.user.id, cargarChat]);

  React.useEffect(() => {
    if (tab === 'guerras') { cargarGuerras(); cargarTodosClanes(); cargarRetos(); }
    if (tab === 'chat') { cargarChat(); setMensajesNoLeidos(0); }
  }, [tab, cargarGuerras, cargarTodosClanes, cargarChat]);

  const enviarMensaje = async () => {
    if (!nuevoMsg.trim() || enviandoMsg || cooldownActivo) return;
    const ahora = Date.now();
    if (ahora - ultimoMsgRef.current < 5000) return;
    ultimoMsgRef.current = ahora;
    setCooldownActivo(true);
    setTimeout(() => setCooldownActivo(false), 5000);
    const texto = nuevoMsg.trim();
    setNuevoMsg('');
    const tempId = 'tmp_' + Date.now();
    const tempMsg = { id: tempId, clan_id: miClan?.id, user_id: session.user.id, nickname: miNick, mensaje: texto, created_at: new Date().toISOString() };
    setMensajes(prev => [...prev, tempMsg]);
    setTimeout(() => { chatRef.current?.scrollTo(0, chatRef.current.scrollHeight); }, 30);
    setEnviandoMsg(true);
    await supabase.from('clan_chat').insert({ clan_id: miClan?.id, user_id: session.user.id, nickname: miNick, mensaje: texto });
    setEnviandoMsg(false);
  };

  const calcDuracion = (medallas) => medallas >= 6 ? 3 : medallas >= 3 ? 2 : 1;

  const retarClan = async () => {
    if (guerrerosElegidos.length < 4) return;
    setEnviandoGuerra(true);

    // Guard: no dejar crear si ya hay una guerra 5v5 buscando rival de este clan
    const { data: yaEnCola } = await supabase.from('clan_guerras')
      .select('id').eq('clan_retador_id', miClan?.id).eq('estado', 'buscando_rival').maybeSingle();
    if (yaEnCola) {
      setMsg(' Ya estás en la cola de matchmaking. Esperá a que encuentren un rival.');
      setEnviandoGuerra(false);
      setVistaGuerra('lista');
      return;
    }

    const { data: ventana } = await supabase.from('ventana_transferencias').select('numero_fecha').eq('activa', true).order('numero_fecha', { ascending: false }).limit(1).maybeSingle();
    const jornada = ventana?.numero_fecha || 1;
    const duracion = calcDuracion(miClan?.medallas || 0);

    // Buscar si hay otro clan en la cola
    const { data: enCola } = await supabase.from('clan_guerras')
      .select('id, clan_retador_id, guerreros_retador')
      .eq('estado', 'buscando_rival')
      .eq('formato', '5v5')
      .neq('clan_retador_id', miClan?.id)
      .limit(1).maybeSingle();

    if (enCola) {
      await supabase.from('clan_guerras').update({
        clan_retado_id: miClan?.id,
        guerreros_retado: guerrerosElegidos,
        estado: 'activa',
        tipo_inicio: 'matchmaking',
        jornada_inicio: jornada,
        jornada_fin: jornada + duracion - 1,
        num_fechas: duracion,
      }).eq('id', enCola.id);
      setMsg('¡Rival encontrado! El desafóo está por empezar.');
    } else {
      const { error: errInsert } = await supabase.from('clan_guerras').insert({
        clan_retador_id: miClan?.id,
        estado: 'buscando_rival',
        tipo_inicio: 'matchmaking',
        formato: '5v5',
        jornada_inicio: jornada,
        jornada_fin: jornada + duracion - 1,
        num_fechas: duracion,
        guerreros_retador: guerrerosElegidos,
        es_guerra_principal: true,
      });
      if (errInsert) { alert('Error: ' + errInsert.message); setEnviandoGuerra(false); return; }
      setMsg('Entraste a la cola de matchmaking. Te avisamos cuando encuentren rival.');
    }

    setEnviandoGuerra(false);
    setVistaGuerra('lista');
    setGuerrerosElegidos([]);
    setFormatoGuerra('5v5');
    // Reload con delay para asegurar que el INSERT ya persistió
    setTimeout(() => { cargarGuerras(); cargarRetos(); }, 800);
  };

  const responderGuerra = async (guerraId, aceptar) => {
    if (aceptar) {
      // El capitán/líder elige 5 guerreros — por ahora auto con los miembros disponibles
      const guerrerosAuto = miembros.slice(0, 5).map(m => m.user_id);
      await supabase.from('clan_guerras').update({
        estado: 'activa',
        guerreros_retado: guerrerosAuto,
      }).eq('id', guerraId);
    } else {
      await supabase.from('clan_guerras').update({ estado: 'rechazada' }).eq('id', guerraId);
    }
    cargarGuerras();
  };

  const tabStyle = (t) => ({
    padding: '7px 16px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold',
    fontSize: '0.78rem', border: `1px solid ${tab === t ? miClan?.color||'#00f2ff' : '#1e293b'}`,
    background: tab === t ? `${miClan?.color||'#00f2ff'}22` : '#080d14',
    color: tab === t ? miClan?.color||'#00f2ff' : '#94a3b8', transition: '0.2s',
  });

  return (
    <>
      {/* TABS */}
      <div style={{ display: 'flex', gap: '6px', marginBottom: '16px', flexWrap: 'wrap' }}>
        <button style={tabStyle('actividad')} onClick={() => setTab('actividad')}>Actividad</button>
        <button style={tabStyle('guerras')} onClick={() => setTab('guerras')}>Guerras</button>
        <button style={tabStyle('miembros')} onClick={() => setTab('miembros')}>Miembros ({miembros.length})</button>
        <button style={tabStyle('chat')} onClick={() => { setTab('chat'); setMensajesNoLeidos(0); }}>
          💬 Chat{mensajesNoLeidos > 0 && (
            <span style={{ background: '#ef4444', color: '#fff', borderRadius: '10px', padding: '0px 5px', fontSize: '0.6rem', fontWeight: 'bold', marginLeft: '4px' }}>
              {mensajesNoLeidos}
            </span>
          )}
        </button>
        <button style={tabStyle('palmares')} onClick={() => setTab('palmares')}> Palmarés</button>
      </div>

      {/* ── TAB ACTIVIDAD (Torneos + Prodes) ── */}
      {tab === 'actividad' && (
        <div className="clan-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>

          {/* TORNEOS */}
          <div style={{ ...S.card }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
              <h3 style={{ margin: 0, fontSize: '0.88rem', color: '#e2e8f0', fontWeight: 'bold', letterSpacing: '0.5px' }}>Torneos del Club</h3>
              {(esLider || esColider) && (
                <button onClick={() => setMostrarCrearTorneo(!mostrarCrearTorneo)}
                  style={{ ...S.btn(miClan?.color||'#00f2ff'), fontSize: '0.8rem', padding: '3px 10px' }}>+ Crear</button>
              )}
            </div>
            {mostrarCrearTorneo && (
              <div style={{ background: '#0a0f19', borderRadius: '8px', padding: '10px', marginBottom: '10px', border: `1px solid ${miClan?.color||'#00f2ff'}44` }}>
                <input placeholder="Nombre del torneo..." value={torneoNombre} onChange={e => setTorneoNombre(e.target.value)} style={{ ...S.input, marginBottom: '8px' }} />
                <div style={{ display: 'flex', gap: '6px', marginBottom: '8px' }}>
                  {['tactico','libre'].map(t => (
                    <button key={t} onClick={() => { setTorneoTipo(t); setMsg(''); }}
                      style={{ ...S.btn(torneoTipo === t ? miClan?.color||'#00f2ff' : '#94a3b8'), flex: 1, fontSize: '0.85rem', padding: '5px', opacity: torneoTipo === t ? 1 : 0.5 }}>
                      {t === 'tactico' ? ' Táctico' : ' Libre'}
                    </button>
                  ))}
                </div>
                {msg && <p style={{ color: '#f59e0b', fontSize: '0.88rem', margin: '0 0 8px' }}>{msg}</p>}
                <div style={{ display: 'flex', gap: '6px' }}>
                  <button onClick={crearTorneoClan} disabled={creandoTorneo || !torneoNombre.trim()}
                    style={{ ...S.btn(miClan?.color||'#00f2ff'), flex: 1, opacity: (!torneoNombre.trim() || creandoTorneo) ? 0.5 : 1, fontSize: '0.88rem' }}>
                    {creandoTorneo ? 'Creando...' : 'Crear'}
                  </button>
                  <button onClick={() => { setMostrarCrearTorneo(false); setTorneoNombre(''); }} style={S.btn('#94a3b8')}>✕</button>
                </div>
              </div>
            )}
            {torneosClan.length === 0
              ? <p style={{ color: '#94a3b8', fontSize: '0.82rem', margin: 0, textAlign: 'center', padding: '10px 0' }}>
                  {(esLider || esColider) ? 'Creá el primer torneo' : 'Sin torneos activos'}
                </p>
              : <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  {torneosClan.map(t => {
                    const estaInscripto = (t.torneo_participantes || []).some(p => p.user_id === session.user.id);
                    const color = miClan?.color || '#00f2ff';
                    return (
                    <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', background: '#0a0f19', borderRadius: '7px', border: `1px solid ${estaInscripto ? '#22c55e33' : '#1e293b'}` }}>
                      <div style={{ flexShrink: 0, textAlign: 'center' }}>
                        <span style={{ fontSize: '1.2rem' }}>{t.tipo === 'tactico' ? '' : ''}</span>
                        <p style={{ margin: '1px 0 0', color: t.tipo === 'tactico' ? '#00f2ff' : '#a855f7', fontSize: '0.65rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{t.tipo === 'tactico' ? 'TÁCTICO' : 'LIBRE'}</p>
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <p style={{ margin: 0, color: '#e2e8f0', fontSize: '0.78rem', fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.nombre}</p>
                        <p style={{ margin: 0, color: estaInscripto ? '#22c55e' : '#64748b', fontSize: '0.75rem' }}>
                          {estaInscripto ? '✓ Inscripto' : t.tipo === 'tactico' ? 'Necesitás equipo confirmado' : 'Libre para unirse'}
                        </p>
                      </div>
                      <div style={{ display: 'flex', gap: '5px', flexShrink: 0 }}>
                        {!estaInscripto && (
                          <button onClick={() => unirseATorneoClan(t)}
                            style={{ ...S.btn('#22c55e'), fontSize: '0.8rem', padding: '3px 10px' }}>
                            Unirse
                          </button>
                        )}
                        <button onClick={() => navigate(`/torneo/${t.id}`)}
                          style={{ ...S.btn(color), fontSize: '0.8rem', padding: '3px 10px' }}>Ver →</button>
                      </div>
                    </div>
                    );
                  })}
                </div>
            }
          </div>

          {/* PRODES */}
          <div style={{ ...S.card }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
              <h3 style={{ margin: 0, fontSize: '0.82rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px' }}>Prodes</h3>
              {(esLider || esColider) && (
                <button onClick={() => setMostrarCrearProde(!mostrarCrearProde)}
                  style={{ ...S.btn(miClan?.color||'#00f2ff'), fontSize: '0.8rem', padding: '3px 10px' }}>+ Crear</button>
              )}
            </div>
            {mostrarCrearProde && (
              <div style={{ background: '#0a0f19', borderRadius: '8px', padding: '10px', marginBottom: '10px', border: `1px solid ${miClan?.color||'#00f2ff'}44` }}>
                <input placeholder="Nombre del prode..." value={prodeNombre} onChange={e => setProdeNombre(e.target.value)} style={{ ...S.input, marginBottom: '8px' }} />
                <div style={{ display: 'flex', gap: '6px' }}>
                  <button onClick={crearProdeClan} disabled={creandoProde || !prodeNombre.trim()}
                    style={{ ...S.btn(miClan?.color||'#00f2ff'), flex: 1, opacity: (!prodeNombre.trim() || creandoProde) ? 0.5 : 1, fontSize: '0.88rem' }}>
                    {creandoProde ? 'Creando...' : 'Crear'}
                  </button>
                  <button onClick={() => { setMostrarCrearProde(false); setProdeNombre(''); }} style={S.btn('#94a3b8')}>✕</button>
                </div>
              </div>
            )}
            {prodesClan.length === 0
              ? <p style={{ color: '#94a3b8', fontSize: '0.82rem', margin: 0, textAlign: 'center', padding: '10px 0' }}>
                  {(esLider || esColider) ? 'Creá el primer prode' : 'Sin prodes activos'}
                </p>
              : <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  {prodesClan.map(t => (
                    <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', background: '#0a0f19', borderRadius: '7px', border: '1px solid #1e293b' }}>
                      <div style={{ flexShrink: 0, textAlign: 'center' }}>
                        <span style={{ fontSize: '1.2rem' }}></span>
                        <p style={{ margin: '1px 0 0', color: '#f59e0b', fontSize: '0.65rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px' }}>PRODE</p>
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <p style={{ margin: 0, color: '#e2e8f0', fontSize: '0.78rem', fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.nombre}</p>
                        <p style={{ margin: 0, color: '#64748b', fontSize: '0.75rem' }}>Cód: {t.codigo_invitacion}</p>
                      </div>
                      <button onClick={() => navigate(`/prode?id=${t.id}`)}
                        style={{ ...S.btn(miClan?.color||'#00f2ff'), fontSize: '0.8rem', padding: '3px 10px', flexShrink: 0 }}>Ver →</button>
                    </div>
                  ))}
                </div>
            }
          </div>


        </div>
      )}

      {/* ── TAB GUERRAS ── */}
      {tab === 'guerras' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>

          {/* Stats del clan en guerras */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '10px' }}>
            {[
              { label: 'Medallas', val: miClan?.medallas || 0, color: '#f59e0b', icon: '🏅' },
              { label: 'Guerras ganadas', val: miClan?.guerras_ganadas || 0, color: '#22c55e',},
              { label: 'Guerras jugadas', val: miClan?.guerras_jugadas || 0, color: '#94a3b8',},
            ].map(({ label, val, color, icon }) => (
              <div key={label} style={{ ...S.card, textAlign: 'center' }}>
                <p style={{ fontSize: '1.2rem', margin: '0 0 4px' }}>{icon}</p>
                <p style={{ color, fontSize: '1.5rem', fontWeight: 'bold', margin: 0 }}>{val}</p>
                <p style={{ color: '#475569', fontSize: '0.78rem', margin: '4px 0 0', textTransform: 'uppercase', letterSpacing: '1px' }}>{label}</p>
              </div>
            ))}
          </div>

          {/* Duración según medallas */}
          <div style={{ ...S.card, display: 'flex', alignItems: 'center', gap: '10px', background: `${miClan?.color||'#00f2ff'}0a`, border: `1px solid ${miClan?.color||'#00f2ff'}33` }}>
            <span style={{ fontSize: '1.1rem' }}>ℹ️</span>
            <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.78rem' }}>
              Con <b style={{ color: miClan?.color||'#00f2ff' }}>{miClan?.medallas || 0} medallas</b>, tus guerras duran <b style={{ color: miClan?.color||'#00f2ff' }}>{calcDuracion(miClan?.medallas || 0)} fecha{calcDuracion(miClan?.medallas || 0) > 1 ? 's' : ''}</b>
              {' '}· Se desbloquean más fechas con 3 y 6 medallas
            </p>
          </div>

          {/* Acciones */}
          {(esLider || esColider) && vistaGuerra === 'lista' && (() => {
            const guerraPrincipalActiva = guerras.some(g =>
              g.es_guerra_principal && ['activa','pendiente'].includes(g.estado)
            );
            const buscandoRival = guerras.some(g =>
              g.es_guerra_principal && g.estado === 'buscando_rival' && g.clan_retador_id === miClan?.id
            );
            if (buscandoRival) return (
              <div style={{ alignSelf: 'flex-start', padding: '10px 18px', background: '#f59e0b10', border: '2px solid #f59e0b55', borderRadius: '8px', color: '#fbbf24', fontSize: '0.9rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ animation: 'spin 1.2s linear infinite', display: 'inline-block' }}></span>
                Buscando clan rival... (en matchmaking)
              </div>
            );
            if (guerraPrincipalActiva) return (
              <div style={{ alignSelf: 'flex-start', padding: '8px 16px', background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '8px', color: '#334155', fontSize: '0.85rem' }}>
                Ya tenés un desafío en curso esta jornada
              </div>
            );
            return (
              <button onClick={() => setVistaGuerra('retar')} style={{ ...S.btn(miClan?.color||'#00f2ff'), alignSelf: 'flex-start' }}>
                Retar a un club
              </button>
            );
          })()}

          {/* Formulario retar */}
          {vistaGuerra === 'retar' && (
            <div style={{ ...S.card, border: `1px solid ${miClan?.color||'#00f2ff'}44` }}>
              <h3 style={{ margin: '0 0 4px', color: miClan?.color||'#00f2ff', fontSize: '0.9rem' }}>Desafío del clbu — 5v5</h3>
              <p style={{ color: '#475569', fontSize: '0.85rem', margin: '0 0 14px' }}>
                Elegí hasta 5 guerreros — el sistema te empareja automáticamente con otro clan. Si tenés menos de 5 podés competir igual.
              </p>

              {/* Elegir guerreros */}
              <p style={{ color: '#94a3b8', fontSize: '0.88rem', margin: '0 0 8px' }}>
                Elegí tus guerreros ({guerrerosElegidos.length}/5 — mínimo 4):
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '14px' }}>
                {miembros.map(m => {
                  const sel = guerrerosElegidos.includes(m.user_id);
                  return (
                    <div key={m.user_id} onClick={() => {
                      if (sel) setGuerrerosElegidos(prev => prev.filter(id => id !== m.user_id));
                      else if (guerrerosElegidos.length < (FORMATOS[formatoGuerra]?.guerreros || 5)) setGuerrerosElegidos(prev => [...prev, m.user_id]);
                    }} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 10px', borderRadius: '7px', cursor: 'pointer',
                      background: sel ? '#22c55e15' : '#0a0f19',
                      border: `1px solid ${sel ? '#22c55e' : '#1e293b'}` }}>
                      <span style={{ color: sel ? '#22c55e' : '#334155', fontSize: '0.8rem' }}>{sel ? '✓' : '○'}</span>
                      <span style={{ color: sel ? '#e2e8f0' : '#94a3b8', fontSize: '0.85rem' }}>{m.perfiles?.nickname || 'Sin nick'}</span>
                      <span style={{ color: '#475569', fontSize: '0.8rem', marginLeft: 'auto' }}>{m.rol === 'lider' ? '👑' : m.rol === 'colider' ? '' : ''}</span>
                    </div>
                  );
                })}
              </div>

              <div style={{ background: '#0a0f19', border: '1px solid #1e293b', borderRadius: '8px', padding: '10px 12px', marginBottom: '14px' }}>
                <p style={{ color: '#475569', fontSize: '0.85rem', margin: 0 }}>
                  🎲 El rival se asigna automáticamente por matchmaking. Si no hay clubes en la cola, quedás esperando hasta que otro clan se sume.
                </p>
              </div>

              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <button onClick={retarClan} disabled={guerrerosElegidos.length < 4 || enviandoGuerra}
                  style={{ ...S.btn(miClan?.color||'#00f2ff'), flex: 1, minWidth: '200px', opacity: guerrerosElegidos.length < 4 ? 0.4 : 1 }}>
                  {enviandoGuerra ? 'Buscando rival...' : `Entrar al matchmaking (${guerrerosElegidos.length} elegidos)`}
                </button>
                <button onClick={() => { setVistaGuerra('lista'); setClanRetadoId(''); setGuerrerosElegidos([]); }} style={S.btn('#94a3b8')}>✕</button>
              </div>
            </div>
          )}

          {/* ── Retos (cualquier miembro puede crear) ── */}
          <div style={{ borderTop: '1px solid #1e293b', paddingTop: '12px', marginTop: '4px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
              <div>
                <p style={{ margin: 0, color: '#e2e8f0', fontSize: '0.85rem', fontWeight: 'bold' }}> Retos</p>
                <p style={{ margin: '2px 0 0', color: '#475569', fontSize: '0.8rem' }}>Cualquier miembro puede proponer — el líder aprueba</p>
              </div>
              <button onClick={() => setVistaReto(vistaReto ? null : 'crear')}
                style={{ ...S.btn(miClan?.color||'#00f2ff'), fontSize: '0.85rem', padding: '5px 12px' }}>
                {vistaReto ? '✕' : '+ Crear reto'}
              </button>
            </div>

            {/* Formulario crear reto */}
            {vistaReto === 'crear' && (
              <div style={{ ...S.card, border: `1px solid ${miClan?.color||'#00f2ff'}33`, marginBottom: '10px' }}>
                <p style={{ color: '#475569', fontSize: '0.85rem', margin: '0 0 8px', textTransform: 'uppercase', letterSpacing: '1px' }}>Formato</p>
                <div style={{ display: 'flex', gap: '6px', marginBottom: '12px' }}>
                  {['2v2','3v3','7v7','11v11'].map(fmt => {
                    const pts = { '2v2':25,'3v3':35,'7v7':80,'11v11':100 };
                    return (
                      <button key={fmt} onClick={() => { setFormatoReto(fmt); setMiembrosReto([]); }}
                        style={{ padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.88rem',
                          border: `1px solid ${formatoReto === fmt ? miClan?.color||'#00f2ff' : '#1e293b'}`,
                          background: formatoReto === fmt ? `${miClan?.color||'#00f2ff'}22` : '#0a0f19',
                          color: formatoReto === fmt ? miClan?.color||'#00f2ff' : '#94a3b8' }}>
                        {fmt} <span style={{ color: '#475569', fontSize: '0.78rem' }}>+{pts[fmt]}pts</span>
                      </button>
                    );
                  })}
                </div>

                {/* Selector de modo */}
                <p style={{ color: '#475569', fontSize: '0.85rem', margin: '0 0 8px', textTransform: 'uppercase', letterSpacing: '1px' }}>Modo</p>
                <div style={{ display: 'flex', gap: '6px', marginBottom: '12px' }}>
                  {[['tactico','Táctico'],['libre','Libre']].map(([m, label]) => (
                    <button key={m} onClick={() => setModoReto(m)}
                      style={{ padding: '5px 14px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.88rem',
                        border: `1px solid ${modoReto === m ? miClan?.color||'#00f2ff' : '#1e293b'}`,
                        background: modoReto === m ? `${miClan?.color||'#00f2ff'}22` : '#0a0f19',
                        color: modoReto === m ? miClan?.color||'#00f2ff' : '#94a3b8' }}>
                      {label}
                    </button>
                  ))}
                </div>

                <p style={{ color: '#475569', fontSize: '0.85rem', margin: '0 0 8px' }}>
                  Elegí {formatoReto.split('v')[0]} miembros ({miembrosReto.length}/{formatoReto.split('v')[0]}):
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '12px' }}>
                  {miembros.map(m => {
                    const sel = miembrosReto.includes(m.user_id);
                    const max = parseInt(formatoReto.split('v')[0]);
                    return (
                      <div key={m.user_id} onClick={() => {
                        if (sel) setMiembrosReto(prev => prev.filter(id => id !== m.user_id));
                        else if (miembrosReto.length < max) setMiembrosReto(prev => [...prev, m.user_id]);
                      }} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 10px', borderRadius: '7px', cursor: 'pointer',
                        background: sel ? '#22c55e15' : '#0a0f19', border: `1px solid ${sel ? '#22c55e' : '#1e293b'}` }}>
                        <span style={{ color: sel ? '#22c55e' : '#334155', fontSize: '0.8rem' }}>{sel ? '✓' : '○'}</span>
                        <span style={{ color: sel ? '#e2e8f0' : '#94a3b8', fontSize: '0.85rem' }}>{m.perfiles?.nickname || 'Sin nick'}</span>
                        {m.user_id === session.user.id && <span style={{ color: '#475569', fontSize: '0.78rem', marginLeft: 'auto' }}>vos</span>}
                      </div>
                    );
                  })}
                </div>
                <button onClick={crearReto}
                  disabled={miembrosReto.length < parseInt(formatoReto.split('v')[0]) || enviandoReto}
                  style={{ ...S.btn(miClan?.color||'#00f2ff'), width: '100%', opacity: miembrosReto.length < parseInt(formatoReto.split('v')[0]) ? 0.4 : 1 }}>
                  {enviandoReto ? 'Enviando...' : `Enviar al líder · ${modoReto === 'tactico' ? 'Táctico' : 'Libre'}`}
                </button>
              </div>
            )}

            {/* Lista de retos */}
            {retos.filter(r => r.estado !== 'expirado').length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {retos.filter(r => r.estado !== 'expirado').map(r => {
                  const esPendiente = r.estado === 'pendiente_aprobacion';
                  const esBuscando = r.estado === 'buscando';
                  const esEmparejado = r.estado === 'emparejado' || r.estado === 'finalizado';
                  const esExpirado = r.estado === 'expirado';

                  const esFinaliz = r.estado === 'finalizado';
                  const labelEstado = esPendiente ? ' Pendiente aprobación' : esBuscando ? ' Buscando rival...' : esFinaliz ? '✓ Finalizado' : esEmparejado ? 'En curso' : '❌ Expirado';
                  const colorEstadoFinal = esPendiente ? '#f59e0b' : esBuscando ? '#3b82f6' : esFinaliz ? '#94a3b8' : esEmparejado ? '#22c55e' : '#334155';
                  return (
                    <div key={r.id} style={{ ...S.card, padding: '10px 14px', border: `1px solid ${colorEstadoFinal}22`, cursor: esEmparejado ? 'pointer' : 'default' }}
                      onClick={async () => {
                      if (!esEmparejado || !r.guerra_id) return;
                      setRetoDetalle(r);
                      // Buscar la guerra — primero en state, si no en DB
                      let g = guerras.find(g => g.id === r.guerra_id);
                      if (!g) {
                        const { data: gDb } = await supabase.from('clan_guerras').select('*').eq('id', r.guerra_id).maybeSingle();
                        g = gDb;
                      }
                      const suyos = g ? (g.clan_retador_id === miClan?.id ? g.guerreros_retado : g.guerreros_retador) : [];
                      const nuestros = r.miembros || [];
                      const todosGuerreros = [...new Set([...nuestros, ...(suyos||[])])];
                      if (suyos?.length) {
                        const { data } = await supabase.from('perfiles').select('id, nickname').in('id', suyos);
                        const map = {};
                        (data || []).forEach(p => { map[p.id] = p.nickname; });
                        setRivalesNicks(map);
                      }
                      // Cargar puntos de los guerreros en la jornada de la guerra
                      if (todosGuerreros.length) {
                        const jornadaPuntos = g?.jornada_inicio || r?.jornada_inicio || 1;
                        const modo = g?.modo || r.modo || 'tactico';
                        const { data: torneos } = await supabase.from('torneos').select('id').eq('tipo', modo);
                        const torneoIds = (torneos||[]).map(t => t.id);
                        if (torneoIds.length) {
                          const { data: fechas } = await supabase.from('torneo_fechas').select('id').in('torneo_id', torneoIds).eq('numero_fecha', jornadaPuntos);
                          const fechaIds = (fechas||[]).map(f => f.id);
                          if (fechaIds.length) {
                            const { data: pts } = await supabase.from('torneo_puntos').select('user_id, puntos').in('fecha_id', fechaIds).in('user_id', todosGuerreros);
                            const map = {};
                            (pts||[]).forEach(p => { map[p.user_id] = Math.max(map[p.user_id]||0, p.puntos); });
                            setPuntosGuerra(map);
                          }
                        }
                      }
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ background: '#1e293b', color: '#94a3b8', borderRadius: '4px', padding: '2px 7px', fontSize: '0.85rem', fontWeight: 'bold' }}>{r.formato}</span>
                        <span style={{ color: colorEstadoFinal, fontSize: '0.88rem', fontWeight: 'bold', flex: 1 }}>{labelEstado}</span>
                        <span style={{ color: '#334155', fontSize: '0.78rem' }}>{r.miembros?.length || 0} miembros</span>
                        {esEmparejado && <span style={{ color: '#475569', fontSize: '0.78rem' }}>Ver duelo →</span>}
                        {esPendiente && (esLider || esColider) && (
                          <div style={{ display: 'flex', gap: '5px' }}>
                            <button onClick={e => { e.stopPropagation(); aprobarReto(r.id, true); }} style={{ ...S.btn('#22c55e'), fontSize: '0.8rem', padding: '3px 10px' }}>✓ Aprobar</button>
                            <button onClick={e => { e.stopPropagation(); aprobarReto(r.id, false); }} style={{ ...S.btn('#ef4444'), fontSize: '0.8rem', padding: '3px 8px' }}>✕</button>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Guerras 5v5 buscando rival — siempre visible al tope */}
          {guerras.filter(g => g.estado === 'buscando_rival' && g.clan_retador_id === miClan?.id).length > 0 && (
            <div style={{ marginBottom: '12px' }}>
              {guerras.filter(g => g.estado === 'buscando_rival' && g.clan_retador_id === miClan?.id).map(g => (
                <div key={g.id} style={{ ...S.card, border: '2px solid #f59e0b66', padding: '14px 18px', background: '#f59e0b08' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
                    <div>
                      <span style={{ color: '#fbbf24', fontWeight: 'bold', fontSize: '1rem' }}>Guerra 5v5 — Buscando rival...</span>
                      <p style={{ color: '#94a3b8', fontSize: '0.82rem', margin: '4px 0 0' }}>
                        {g.guerreros_retador?.length || 0} guerreros listos · En cola de matchmaking. Avisamos cuando encontremos rival.
                      </p>
                    </div>
                    {(esLider || esColider) && (
                      <button onClick={async () => {
                        if (!window.confirm('¿Salir del matchmaking?')) return;
                        await supabase.from('clan_guerras').delete().eq('id', g.id);
                        cargarGuerras();
                      }} style={{ background: '#ef444422', border: '1px solid #ef444444', borderRadius: '6px', padding: '6px 14px', color: '#ef4444', fontSize: '0.85rem', cursor: 'pointer', flexShrink: 0, fontWeight: 'bold' }}>
                        Cancelar
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {guerras.filter(g => g.estado !== 'buscando_rival').length === 0 ? (
            <div style={{ ...S.card, textAlign: 'center', padding: '32px' }}>
              <p style={{ fontSize: '2rem', margin: '0 0 8px' }}></p>
              <p style={{ color: '#94a3b8', margin: 0 }}>Sin guerras todavía</p>
              <p style={{ color: '#475569', fontSize: '0.78rem', margin: '4px 0 0' }}>
                {(esLider || esColider) ? 'Retá a otro clan para empezar' : 'El líder puede iniciar una guerra'}
              </p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {guerras.filter(g => g.estado !== 'buscando_rival' && g.es_guerra_principal !== false).map(g => {
                const somoRetador = g.clan_retador_id === miClan?.id;
                const rivalId = somoRetador ? g.clan_retado_id : g.clan_retador_id;
                const rivalClan = todosClanes.find(c => c.id === rivalId);
                const esPendiente = g.estado === 'pendiente';
                const esActiva = g.estado === 'activa';
                const esFinalizada = g.estado === 'finalizada';
                const ganamos = g.ganador_clan_id === miClan?.id;
                const empate = esFinalizada && !g.ganador_clan_id;
                const ptsNuestros = somoRetador ? (g.puntos_retador||0) : (g.puntos_retado||0);
                const ptsSuyos = somoRetador ? (g.puntos_retado||0) : (g.puntos_retador||0);

                const estadoColor = esPendiente ? '#f59e0b' : esActiva ? '#22c55e' : ganamos ? '#22c55e' : empate ? '#94a3b8' : '#ef4444';
                const estadoLabel = esPendiente ? (somoRetador ? ' Esperando respuesta' : 'Te desafiaron') : esActiva ? ' En curso' : ganamos ? ' Victoria' : empate ? ' Empate' : ' Derrota';

                return (
                  <div key={g.id} style={{ ...S.card, border: `1px solid ${estadoColor}33`, padding: '14px 18px', cursor: esFinalizada || esActiva ? 'pointer' : 'default' }}
                    onClick={async () => {
                      if (!esFinalizada && !esActiva) return;
                      const nuestros = somoRetador ? (g.guerreros_retador||[]) : (g.guerreros_retado||[]);
                      const suyos = somoRetador ? (g.guerreros_retado||[]) : (g.guerreros_retador||[]);
                      setRetoDetalle({ ...g, formato: g.formato || '5v5', miembros: nuestros, guerra_id: g.id, modo: 'tactico', _esGuerraPrincipal: true });
                      if (suyos.length) {
                        const { data } = await supabase.from('perfiles').select('id, nickname').in('id', suyos);
                        const map = {}; (data||[]).forEach(p => { map[p.id] = p.nickname; }); setRivalesNicks(map);
                      }
                      const todosGuerreros = [...new Set([...nuestros, ...suyos])];
                      if (todosGuerreros.length) {
                        const jornada = g?.jornada_inicio || 1;
                        const { data: torneos } = await supabase.from('torneos').select('id').eq('tipo', 'tactico');
                        const torneoIds = (torneos||[]).map(t => t.id);
                        if (torneoIds.length) {
                          const { data: fechas } = await supabase.from('torneo_fechas').select('id').in('torneo_id', torneoIds).eq('numero_fecha', jornada);
                          const fechaIds = (fechas||[]).map(f => f.id);
                          if (fechaIds.length) {
                            const { data: pts } = await supabase.from('torneo_puntos').select('user_id, puntos').in('fecha_id', fechaIds).in('user_id', todosGuerreros);
                            const map = {}; (pts||[]).forEach(p => { map[p.user_id] = Math.max(map[p.user_id]||0, p.puntos); }); setPuntosGuerra(map);
                          }
                        }
                      }
                    }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', width: '100%' }}>
                      {/* Izquierda: escudo + nombre + puntaje */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, justifyContent: 'flex-end' }}>
                        <div style={{ textAlign: 'center' }}>
                          <span style={{ fontSize: '1.6rem' }}>{EMBLEMAS[miClan?.emblema] || ''}</span>
                          <p style={{ margin: '2px 0 0', color: miClan?.color||'#00f2ff', fontSize: '0.82rem', fontWeight: 'bold' }}>{miClan?.nombre}</p>
                          <p style={{ margin: 0, color: '#64748b', fontSize: '0.75rem' }}>[{miClan?.tag}]</p>
                        </div>
                        <span style={{ color: esFinalizada ? (ganamos ? '#22c55e' : empate ? '#94a3b8' : '#ef4444') : '#e2e8f0', fontSize: '2rem', fontWeight: 'bold' }}>
                          {esActiva || esFinalizada ? ptsNuestros : '—'}
                        </span>
                      </div>
                      {/* Centro: VS + formato */}
                      <div style={{ textAlign: 'center', flexShrink: 0 }}>
                        <p style={{ margin: 0, color: '#475569', fontSize: '0.9rem' }}>VS</p>
                        <span style={{ background: '#1e293b', color: '#64748b', borderRadius: '4px', padding: '1px 7px', fontSize: '0.78rem', fontWeight: 'bold' }}>{g.formato || '5v5'}</span>
                      </div>
                      {/* Derecha: puntaje + escudo + nombre */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, justifyContent: 'flex-start' }}>
                        <span style={{ color: esFinalizada ? (ganamos ? '#ef4444' : empate ? '#94a3b8' : '#22c55e') : '#e2e8f0', fontSize: '2rem', fontWeight: 'bold' }}>
                          {esActiva || esFinalizada ? ptsSuyos : '—'}
                        </span>
                        <div style={{ textAlign: 'center' }}>
                          <span style={{ fontSize: '1.6rem' }}></span>
                          <p style={{ margin: '2px 0 0', color: rivalClan?.color||'#94a3b8', fontSize: '0.82rem', fontWeight: 'bold' }}>{rivalClan?.nombre || '...'}</p>
                          <p style={{ margin: 0, color: '#64748b', fontSize: '0.75rem' }}>[{rivalClan?.tag || '?'}]</p>
                        </div>
                      </div>
                      </div>
                      {/* Badge resultado — debajo, centrado, sin superposición */}
                      {esFinalizada && (
                        <span style={{ color: ganamos ? '#22c55e' : empate ? '#94a3b8' : '#ef4444', fontSize: '0.88rem', fontWeight: 'bold', background: (ganamos ? '#22c55e' : empate ? '#94a3b8' : '#ef4444') + '22', border: `1px solid ${(ganamos ? '#22c55e' : empate ? '#94a3b8' : '#ef4444')}55`, borderRadius: '8px', padding: '6px 20px' }}>
                          {ganamos ? ' VICTORIA' : empate ? ' EMPATE' : ' DERROTA'}
                        </span>
                      )}
                      {esPendiente && !somoRetador && (esLider || esColider) && (
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button onClick={e => { e.stopPropagation(); responderGuerra(g.id, true); }} style={{ ...S.btn('#22c55e'), fontSize: '0.85rem', padding: '5px 12px' }}>✓ Aceptar</button>
                          <button onClick={e => { e.stopPropagation(); responderGuerra(g.id, false); }} style={{ ...S.btn('#ef4444'), fontSize: '0.85rem', padding: '5px 12px' }}>✕</button>
                        </div>
                      )}
                      {esPendiente && <span style={{ flexShrink: 0, color: '#f59e0b', fontSize: '0.85rem' }}>⏳ {somoRetador ? 'Esperando' : 'Te desafiaron'}</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* ── TAB CHAT ── */}
      {tab === 'chat' && (
        <div style={{ ...S.card, display: 'flex', flexDirection: 'column', height: '500px' }}>
          {(mensajeFijado || esLider || esColider) && (
            <div style={{ background: '#f59e0b0d', border: '1px solid #f59e0b33', borderRadius: '8px', padding: '10px 12px', marginBottom: '12px' }}>
              {editandoFijado ? (
                <div style={{ display: 'flex', gap: '6px' }}>
                  <input value={tempFijado} onChange={e => setTempFijado(e.target.value)} maxLength={200}
                    placeholder="Escribí el aviso fijado..."
                    style={{ ...S.input, flex: 1, fontSize: '0.8rem' }} />
                  <button onClick={async () => {
                    await supabase.from('clanes').update({ mensaje_fijado: tempFijado.trim() || null }).eq('id', miClan?.id);
                    setMensajeFijado(tempFijado.trim());
                    setEditandoFijado(false);
                  }} style={{ ...S.btn('#f59e0b'), padding: '6px 12px', fontSize: '0.85rem' }}>✓</button>
                  <button onClick={() => setEditandoFijado(false)} style={{ ...S.btn('#94a3b8'), padding: '6px 10px', fontSize: '0.85rem' }}>✕</button>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                  <span style={{ fontSize: '0.9rem', flexShrink: 0 }}>📌</span>
                  <p style={{ margin: 0, color: '#fde68a', fontSize: '0.8rem', flex: 1, lineHeight: 1.4 }}>
                    {mensajeFijado || <span style={{ color: '#475569', fontStyle: 'italic' }}>Sin aviso fijado</span>}
                  </p>
                  {(esLider || esColider) && (
                    <button onClick={() => { setTempFijado(mensajeFijado); setEditandoFijado(true); }}
                      style={{ background: 'none', border: 'none', color: '#475569', cursor: 'pointer', fontSize: '0.85rem', flexShrink: 0, padding: '0 4px' }}>✏️</button>
                  )}
                </div>
              )}
            </div>
          )}
          <h3 style={{ margin: '0 0 12px', color: '#94a3b8', fontSize: '0.88rem', textTransform: 'uppercase', letterSpacing: '2px' }}>💬 Chat del clan</h3>

          {/* Mensajes */}
          <div ref={chatRef} style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '12px', paddingRight: '4px' }}>
            {mensajes.length === 0 ? (
              <p style={{ color: '#334155', textAlign: 'center', margin: 'auto', fontSize: '0.85rem' }}>Sin mensajes todavía — ¡rompé el hielo!</p>
            ) : mensajes.map((m, i) => {
              const esMio = m.user_id === session.user.id;
              return (
                <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: esMio ? 'flex-end' : 'flex-start' }}>
                  {(!i || mensajes[i-1]?.user_id !== m.user_id) && (
                    <span style={{ color: esMio ? miClan?.color||'#00f2ff' : '#94a3b8', fontSize: '0.78rem', marginBottom: '2px', fontWeight: 'bold' }}>
                      {esMio ? 'Vos' : m.nickname}
                    </span>
                  )}
                  <div style={{ maxWidth: '75%', padding: '7px 12px', borderRadius: esMio ? '12px 12px 2px 12px' : '12px 12px 12px 2px',
                    background: esMio ? `${miClan?.color||'#00f2ff'}22` : '#0f172a',
                    border: `1px solid ${esMio ? miClan?.color||'#00f2ff' + '44' : '#1e293b'}` }}>
                    <p style={{ margin: 0, color: '#e2e8f0', fontSize: '0.85rem', wordBreak: 'break-word' }}>{m.mensaje}</p>
                  </div>
                  <span style={{ color: '#1e293b', fontSize: '0.58rem', marginTop: '2px' }}>
                    {new Date(m.created_at).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>
              );
            })}
          </div>

          {/* Input */}
          <div style={{ display: 'flex', gap: '8px' }}>
            <input
              value={nuevoMsg}
              onChange={e => setNuevoMsg(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && !e.shiftKey && enviarMensaje()}
              placeholder="Escribí un mensaje..."
              maxLength={500}
              style={{ ...S.input, flex: 1 }}
            />
            <button onClick={enviarMensaje} disabled={!nuevoMsg.trim() || enviandoMsg || cooldownActivo}
              style={{ ...S.btn(miClan?.color||'#00f2ff'), padding: '9px 18px', flexShrink: 0, opacity: (!nuevoMsg.trim() || cooldownActivo) ? 0.4 : 1 }}>
              {enviandoMsg ? '...' : '↑'}
            </button>
          </div>
          {cooldownActivo && (
            <p style={{ color: '#475569', fontSize: '0.78rem', margin: '4px 0 0', textAlign: 'right' }}>
              Esperá 5 seg entre mensajes
            </p>
          )}
        </div>
      )}

      {/* ── TAB MIEMBROS ── */}
      {tab === 'miembros' && (
        <div style={{ ...S.card }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {miembros.map((m, i) => {
              const rango = calcularRango(m.perfiles?.puntos_ranked || 0);
              const esMiUsuario = m.user_id === session.user.id;
              return (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '9px 12px', borderRadius: '8px', background: esMiUsuario ? '#00f2ff08' : 'transparent', border: `1px solid ${esMiUsuario ? '#00f2ff22' : 'transparent'}` }}>
                  <span style={{ color: '#475569', fontSize: '0.82rem', width: '18px', textAlign: 'right', flexShrink: 0 }}>#{i+1}</span>
                  <span
                    onClick={() => navigate(`/palmares/${m.user_id}`)}
                    style={{ color: esMiUsuario ? '#00f2ff' : '#e2e8f0', fontWeight: esMiUsuario ? 'bold' : 'normal', flex: 1, fontSize: '0.88rem', cursor: 'pointer' }}
                    onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'}
                    onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'}
                  >
                    {m.perfiles?.nickname || 'Sin nick'}
                  </span>
                  <span style={{ color: m.rol === 'lider' ? '#f59e0b' : m.rol === 'colider' ? '#a855f7' : 'transparent', fontSize: '0.8rem', fontWeight: 'bold', flexShrink: 0, minWidth: '60px', textAlign: 'right' }}>
                    {m.rol === 'lider' ? '👑 Líder' : m.rol === 'colider' ? 'Co-líder' : ''}
                  </span>
                  {esLider && !esMiUsuario && (
                    <div style={{ display: 'flex', gap: '4px', flexShrink: 0, width: '64px', justifyContent: 'flex-end' }}>
                      {m.rol === 'miembro' && <button onClick={() => cambiarRol(m.user_id, 'colider')} title="Promover" style={{ background: '#a855f722', border: '1px solid #a855f744', borderRadius: '5px', padding: '3px 7px', color: '#a855f7', fontSize: '0.78rem', cursor: 'pointer' }}>↑</button>}
                      {m.rol === 'colider' && <button onClick={() => cambiarRol(m.user_id, 'miembro')} title="Degradar" style={{ background: '#47556922', border: '1px solid #47556944', borderRadius: '5px', padding: '3px 7px', color: '#94a3b8', fontSize: '0.78rem', cursor: 'pointer' }}>↓</button>}
                      <button onClick={() => expulsarMiembro(m.user_id)} title="Expulsar" style={{ background: '#ef444422', border: '1px solid #ef444444', borderRadius: '5px', padding: '3px 7px', color: '#ef4444', fontSize: '0.78rem', cursor: 'pointer' }}>✕</button>
                    </div>
                  )}
                  {esLider && esMiUsuario && <div style={{ width: '64px', flexShrink: 0 }} />}
                </div>
              );
            })}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
            {!esLider && <button onClick={salirDelClan} style={{ ...S.btn('#ef4444'), fontSize: '0.78rem' }}>Salir del clan</button>}
            {esLider && <button onClick={eliminarClan} style={{ ...S.btn('#ef4444'), fontSize: '0.78rem', opacity: 0.7 }}>🗑️ Eliminar clan</button>}
          </div>
        </div>
      )}

      {/* ── TAB PALMARÉS ── */}
      {tab === 'palmares' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

          {/* Trofeos */}
          <div style={{ ...S.card }}>
            <h3 style={{ color: '#475569', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 14px' }}>Trofeos</h3>
            {(() => {
              const FORMATOS = ['2v2', '3v3', '5v5', '7v7', '11v11'];
              const FORMATO_EMOJI = { '2v2': '', '3v3': '', '5v5': '', '7v7': '', '11v11': '' };
              const FORMATO_COLOR = { '2v2': '#00f2ff', '3v3': '#22c55e', '5v5': '#f59e0b', '7v7': '#f97316', '11v11': '#a855f7' };
              const HITO_DESC = {
                'Primera Sangre': 'Ganaste tu primera guerra del club',
                'Veteranos':      'Ganaste 5 guerras de clubes',
                'Élite':          'Ganaste 10 guerras de clubes',
                'En Racha':       'Conseguiste una racha de 3 victorias seguidas',
                'Legendario':     'El club acumuló 100 medallas',
                'Versátil':       'Ganaste con todos los formatos disponibles',
              };

              const tieneFormatos   = FORMATOS.some(f => (guerrasPorFormato[f] || 0) > 0);
              const tieneGuerras    = (miClan?.guerras_ganadas || 0) > 0;
              const tieneHitos      = miClan?.trofeos?.length > 0;
              const tieneTrofeos    = tieneFormatos || tieneGuerras || tieneHitos;

              if (!tieneTrofeos) {
                return (
                  <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <p style={{ fontSize: '1.8rem', margin: '0 0 8px' }}>🏅</p>
                    <p style={{ color: '#64748b', fontSize: '0.85rem', margin: '0 0 4px' }}>Aún sin trofeos</p>
                    <p style={{ color: '#475569', fontSize: '0.88rem', margin: 0 }}>Ganá guerras para desbloquear medallas por formato</p>
                  </div>
                );
              }

              return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                  {/* 1. Medalla de guerras de clanes ganadas */}
                  {tieneGuerras && (
                    <div>
                      <p style={{ color: '#475569', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 10px' }}>Desafío de clubes</p>
                      <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: '4px', background: '#0a0f19', border: '1px solid #f59e0b44', borderRadius: '10px', padding: '12px 20px', minWidth: '80px' }}>
                        <span style={{ fontSize: '1.6rem', lineHeight: 1 }}></span>
                        <span style={{ color: '#f59e0b', fontWeight: 'bold', fontSize: '1.4rem', lineHeight: 1 }}>{miClan.guerras_ganadas}</span>
                        <span style={{ color: '#475569', fontSize: '0.78rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' }}>GUERRAS</span>
                        <span style={{ color: '#334155', fontSize: '0.6rem' }}>{miClan.guerras_ganadas === 1 ? 'ganada' : 'ganadas'}</span>
                      </div>
                    </div>
                  )}

                  {/* 2. Medallas por formato */}
                  {tieneFormatos && (
                    <div>
                      <p style={{ color: '#475569', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 10px' }}>Por formato</p>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                        {FORMATOS.filter(f => (guerrasPorFormato[f] || 0) > 0).map(f => {
                          const count = guerrasPorFormato[f];
                          const color = FORMATO_COLOR[f];
                          return (
                            <div key={f} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', background: '#0a0f19', border: `1px solid ${color}44`, borderRadius: '10px', padding: '12px 16px', minWidth: '72px' }}>
                              <span style={{ fontSize: '1.4rem', lineHeight: 1 }}>{FORMATO_EMOJI[f]}</span>
                              <span style={{ color, fontWeight: 'bold', fontSize: '1.3rem', lineHeight: 1 }}>{count}</span>
                              <span style={{ color: '#475569', fontSize: '0.78rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' }}>{f}</span>
                              <span style={{ color: '#334155', fontSize: '0.6rem' }}>{count === 1 ? 'medalla' : 'medallas'}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* 3. Hitos con tooltip */}
                  {tieneHitos && (
                    <div>
                      <p style={{ color: '#475569', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 10px' }}>Hitos</p>
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        {miClan.trofeos.map((t, i) => (
                          <div key={i} style={{ position: 'relative' }}
                            onMouseEnter={e => e.currentTarget.querySelector('.hito-tooltip').style.display = 'block'}
                            onMouseLeave={e => e.currentTarget.querySelector('.hito-tooltip').style.display = 'none'}
                          >
                            <div style={{ background: '#0a0f19', border: '1px solid #f59e0b55', borderRadius: '10px', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'default' }}>
                              <span style={{ fontSize: '1.2rem' }}>{t.emoji}</span>
                              <div>
                                <p style={{ color: '#f59e0b', fontSize: '0.78rem', fontWeight: 'bold', margin: 0 }}>{t.nombre}</p>
                                {t.fecha && <p style={{ color: '#334155', fontSize: '0.88rem', margin: 0 }}>{t.fecha.slice(0, 10)}</p>}
                              </div>
                            </div>
                            {/* Tooltip */}
                            <div className="hito-tooltip" style={{ display: 'none', position: 'absolute', bottom: 'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)', background: '#0f172a', border: '1px solid #f59e0b44', borderRadius: '8px', padding: '8px 12px', whiteSpace: 'nowrap', zIndex: 100, pointerEvents: 'none' }}>
                              <p style={{ color: '#e2e8f0', fontSize: '0.88rem', margin: 0 }}>{HITO_DESC[t.nombre] || t.nombre}</p>
                              <div style={{ position: 'absolute', bottom: '-5px', left: '50%', transform: 'translateX(-50%)', width: '8px', height: '8px', background: '#0f172a', border: '1px solid #f59e0b44', borderTop: 'none', borderLeft: 'none', rotate: '45deg' }} />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                </div>
              );
            })()}
          </div>


          {/* Ranking interno por medallas */}
          <div style={{ ...S.card }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
              <h3 style={{ color: '#475569', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '2px', margin: 0 }}>Ranking de medallas</h3>
              <span style={{ color: '#334155', fontSize: '0.8rem' }}>Fechas ganadas · Guerras · Desafíos</span>
            </div>
            {(() => {
              const rankingMiembros = [...miembros]
                .sort((a, b) => (b.medallas || 0) - (a.medallas || 0));

              if (rankingMiembros.every(m => !m.medallas || m.medallas === 0)) {
                return (
                  <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <p style={{ fontSize: '1.8rem', margin: '0 0 8px' }}>🎖️</p>
                    <p style={{ color: '#64748b', fontSize: '0.85rem', margin: 0 }}>Todavía no hay medallas — ganá fechas, guerras o desafíos</p>
                  </div>
                );
              }

              return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  {rankingMiembros.map((m, i) => {
                    const esMiUsuario = m.user_id === session.user.id;
                    const posEmoji = i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `#${i+1}`;
                    const medallas = m.medallas || 0;
                    return (
                      <div key={m.user_id} onClick={() => navigate(`/palmares/${m.user_id}`)}
                        style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 12px', borderRadius: '8px', cursor: 'pointer', background: esMiUsuario ? `${miClan?.color||'#00f2ff'}08` : '#0a0f19', border: `1px solid ${esMiUsuario ? (miClan?.color||'#00f2ff') + '33' : '#1e293b'}`, transition: '0.15s' }}
                        onMouseEnter={e => e.currentTarget.style.borderColor = miClan?.color || '#00f2ff'}
                        onMouseLeave={e => e.currentTarget.style.borderColor = esMiUsuario ? (miClan?.color||'#00f2ff') + '33' : '#1e293b'}
                      >
                        <span style={{ fontSize: '0.9rem', minWidth: '24px', textAlign: 'center' }}>{posEmoji}</span>
                        <span style={{ flex: 1, color: esMiUsuario ? miClan?.color || '#00f2ff' : '#e2e8f0', fontWeight: esMiUsuario ? 'bold' : 'normal', fontSize: '0.88rem' }}>
                          {m.perfiles?.nickname || 'Sin nick'}
                          {esMiUsuario && <span style={{ color: '#475569', fontSize: '0.78rem', marginLeft: '6px' }}>· vos</span>}
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <span style={{ fontSize: '0.85rem' }}>🏅</span>
                          <span style={{ color: medallas > 0 ? '#f59e0b' : '#334155', fontWeight: 'bold', fontSize: '1rem', minWidth: '24px', textAlign: 'right' }}>
                            {medallas}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })()}
          </div>

          {/* Historial por torneo y fecha */}
          {historiaFechasClan.length > 0 && (
            <div style={{ ...S.card }}>
              <h3 style={{ color: '#475569', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 14px' }}>Historial por fecha</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {historiaFechasClan.map(torneo => {
                  const color = torneo.tipo === 'libre' ? '#a855f7' : '#00f2ff';
                  const expandido = torneoExpandidoClan === torneo.id;
                  const totalFechasCerradas = torneo.fechas.filter(f => f.cerrada).length;

                  return (
                    <div key={torneo.id} style={{ border: `1px solid ${expandido ? color + '44' : '#1e293b'}`, borderRadius: '10px', overflow: 'hidden', transition: '0.2s' }}>
                      <div
                        onClick={() => setTorneoExpandidoClan(expandido ? null : torneo.id)}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', background: expandido ? `${color}0d` : '#0a0f19', cursor: 'pointer' }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: color, flexShrink: 0 }} />
                          <span style={{ color: '#e2e8f0', fontSize: '0.88rem', fontWeight: '500' }}>{torneo.nombre}</span>
                          <span style={{ color: '#334155', fontSize: '0.8rem', textTransform: 'uppercase' }}>{torneo.tipo}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <span style={{ color: '#475569', fontSize: '0.85rem' }}>{totalFechasCerradas} fechas</span>
                          <span style={{ color: '#475569', fontSize: '0.85rem' }}>{expandido ? '▲' : '▼'}</span>
                        </div>
                      </div>

                      {expandido && (
                        <div style={{ borderTop: `1px solid ${color}22` }}>
                          {torneo.fechas.map((fecha, fi) => {
                            const ganadorNick = miembros.find(m => m.user_id === fecha.ganador)?.perfiles?.nickname;
                            const top3 = [...fecha.jugadores].sort((a, b) => b.puntos - a.puntos).slice(0, 3);

                            return (
                              <div key={fi} style={{ padding: '10px 14px', borderBottom: fi < torneo.fechas.length - 1 ? '1px solid #0f172a' : 'none', background: fecha.cerrada ? 'transparent' : '#f59e0b06' }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: top3.length > 0 ? '8px' : 0 }}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span style={{ color: fecha.cerrada ? '#475569' : '#f59e0b', fontSize: '0.88rem', fontWeight: 'bold' }}>
                                      Fecha {fecha.numero_fecha}
                                    </span>
                                    {!fecha.cerrada && <span style={{ color: '#f59e0b', fontSize: '0.78rem', background: '#f59e0b11', border: '1px solid #f59e0b33', borderRadius: '4px', padding: '1px 6px' }}>En curso</span>}
                                    {fecha.cerrada && ganadorNick && (
                                      <span style={{ color: '#f59e0b', fontSize: '0.85rem' }}> {ganadorNick}</span>
                                    )}
                                  </div>
                                  {fecha.cerrada && !ganadorNick && fecha.jugadores.length === 0 && (
                                    <span style={{ color: '#334155', fontSize: '0.85rem' }}>Sin datos</span>
                                  )}
                                </div>

                                {top3.length > 0 && (
                                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                    {top3.map((j, ji) => {
                                      const nick = miembros.find(m => m.user_id === j.user_id)?.perfiles?.nickname || '?';
                                      const esMiUsuario = j.user_id === session.user.id;
                                      return (
                                        <div key={ji} style={{ display: 'flex', alignItems: 'center', gap: '4px', background: '#0a0f19', borderRadius: '6px', padding: '4px 8px', border: `1px solid ${esMiUsuario ? color + '55' : '#1e293b'}` }}>
                                          <span style={{ fontSize: '0.85rem' }}>{ji === 0 ? '🥇' : ji === 1 ? '🥈' : '🥉'}</span>
                                          <span style={{ color: esMiUsuario ? color : '#94a3b8', fontSize: '0.88rem' }}>{nick}</span>
                                          <span style={{ color: '#475569', fontSize: '0.8rem' }}>{j.puntos}pts</span>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Emblemas desbloqueables por medallas */}
          {(() => {
            const EMBLEMAS_DESBLOQUEABLES = [
              { medallas: 0,   key: 'escudo_1',  emoji: '🛡️',  nombre: 'Escudo',      desbloqueado: true },
              { medallas: 0,   key: 'escudo_2',  emoji: '⚔️',  nombre: 'Espadas',     desbloqueado: true },
              { medallas: 0,   key: 'estrella',  emoji: '⭐',  nombre: 'Estrella',    desbloqueado: true },
              { medallas: 0,   key: 'fuego',     emoji: '🔥',  nombre: 'Fuego',       desbloqueado: true },
              { medallas: 3,   key: 'trofeo',    emoji: '🏆',  nombre: 'Trofeo',      desbloqueado: (miClan?.medallas||0) >= 3 },
              { medallas: 3,   key: 'rayo',      emoji: '⚡',  nombre: 'Rayo',        desbloqueado: (miClan?.medallas||0) >= 3 },
              { medallas: 5,   key: 'corona',    emoji: '👑',  nombre: 'Corona',      desbloqueado: (miClan?.medallas||0) >= 5 },
              { medallas: 5,   key: 'dragon',    emoji: '🐉',  nombre: 'Dragón',      desbloqueado: (miClan?.medallas||0) >= 5 },
              { medallas: 8,   key: 'aguila',    emoji: '🦅',  nombre: 'Águila',      desbloqueado: (miClan?.medallas||0) >= 8 },
              { medallas: 8,   key: 'leon',      emoji: '🦁',  nombre: 'León',        desbloqueado: (miClan?.medallas||0) >= 8 },
              { medallas: 12,  key: 'diamante',  emoji: '💎',  nombre: 'Diamante',    desbloqueado: (miClan?.medallas||0) >= 12 },
              { medallas: 12,  key: 'cohete',    emoji: '🚀',  nombre: 'Cohete',      desbloqueado: (miClan?.medallas||0) >= 12 },
              { medallas: 20,  key: 'lobo',      emoji: '🐺',  nombre: 'Lobo',        desbloqueado: (miClan?.medallas||0) >= 20 },
              { medallas: 20,  key: 'toro',      emoji: '🐂',  nombre: 'Toro',        desbloqueado: (miClan?.medallas||0) >= 20 },
              { medallas: 30,  key: 'calavera',  emoji: '💀',  nombre: 'Calavera',    desbloqueado: (miClan?.medallas||0) >= 30 },
              { medallas: 30,  key: 'planeta',   emoji: '🌍',  nombre: 'Planeta',     desbloqueado: (miClan?.medallas||0) >= 30 },
            ];
            return (
              <div style={{ ...S.card }}>
                <h3 style={{ color: '#475569', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 4px' }}>Emblemas</h3>
                <p style={{ color: '#334155', fontSize: '0.85rem', margin: '0 0 14px' }}>{miClan?.medallas || 0} medallas · desbloqueás más ganando guerras</p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
                  {EMBLEMAS_DESBLOQUEABLES.map(e => (
                    <div key={e.key} style={{
                      textAlign: 'center', padding: '10px 6px', borderRadius: '10px',
                      background: e.desbloqueado ? (miClan?.emblema === e.key ? `${miClan?.color||'#00f2ff'}22` : '#0a0f19') : '#050a0f',
                      border: `1px solid ${e.desbloqueado ? (miClan?.emblema === e.key ? miClan?.color||'#00f2ff' : '#1e293b') : '#0d1520'}`,
                      opacity: e.desbloqueado ? 1 : 0.4,
                      cursor: (e.desbloqueado && esLider) ? 'pointer' : 'default',
                    }} onClick={async () => {
                      if (!e.desbloqueado || !esLider) return;
                      await supabase.from('clanes').update({ emblema: e.key }).eq('id', miClan?.id);
                      window.location.reload();
                    }}>
                      <p style={{ fontSize: '1.5rem', margin: '0 0 4px' }}>{e.emoji}</p>
                      <p style={{ color: e.desbloqueado ? '#e2e8f0' : '#334155', fontSize: '0.78rem', margin: 0, fontWeight: '500' }}>{e.nombre}</p>
                      {!e.desbloqueado && <p style={{ color: '#334155', fontSize: '0.58rem', margin: '2px 0 0' }}>🏅 {e.medallas}</p>}
                      {e.desbloqueado && miClan?.emblema === e.key && <p style={{ color: miClan?.color||'#00f2ff', fontSize: '0.58rem', margin: '2px 0 0' }}>✓ Activo</p>}
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}
        </div>
      )}
    <>
      {/* Modal detalle del reto emparejado */}
      {retoDetalle && (() => {
        const g = guerras.find(g => g.id === retoDetalle.guerra_id);
        const rivalClanId = g ? (g.clan_retador_id === miClan?.id ? g.clan_retado_id : g.clan_retador_id) : null;
        const rivalClan = todosClanes.find(c => c.id === rivalClanId);
        const formatoNum = parseInt(retoDetalle.formato?.split('v')[0]) || 5;
        const nuestros = retoDetalle._esGuerraPrincipal && g
          ? (g.clan_retador_id === miClan?.id ? (g.guerreros_retador||[]) : (g.guerreros_retado||[])).slice(0, formatoNum)
          : (retoDetalle.miembros || []).slice(0, formatoNum);
        const suyosRaw = g ? (g.clan_retador_id === miClan?.id ? g.guerreros_retado : g.guerreros_retador) : [];
        const suyos = (suyosRaw||[]).slice(0, formatoNum);
        const modo = g?.modo || retoDetalle.modo || 'tactico';
        const modoLabel = modo === 'tactico' ? 'Táctico' : 'Libre';
        const modoColor = modo === 'tactico' ? '#00f2ff' : '#a855f7';

        // Calcular marcador acumulado
        const ptsnuestros = nuestros.reduce((acc, uid) => acc + (puntosGuerra[uid] || 0), 0);
        const ptssuyos = (suyos||[]).reduce((acc, uid) => acc + (puntosGuerra[uid] || 0), 0);
        const ganamos = g?.estado === 'finalizada' && g?.ganador_clan_id === miClan?.id;
        const perdimos = g?.estado === 'finalizada' && g?.ganador_clan_id && g?.ganador_clan_id !== miClan?.id;
        const finalizada = g?.estado === 'finalizada';

        const puntosYaCargaron = retoDetalle !== null; // siempre mostrar una vez que abrió el modal

        return (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            onClick={() => { setRetoDetalle(null); setPuntosGuerra({}); }}>
            <div style={{ background: '#0b1120', border: `1px solid ${miClan?.color||'#00f2ff'}44`, borderRadius: '14px', padding: '24px', width: '440px', maxWidth: '95vw' }}
              onClick={e => e.stopPropagation()}>

              {/* Header */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <h3 style={{ margin: 0, color: miClan?.color||'#00f2ff', fontSize: '0.9rem' }}>Reto {retoDetalle.formato}</h3>
                  <span style={{ background: `${modoColor}22`, color: modoColor, border: `1px solid ${modoColor}44`, borderRadius: '4px', padding: '1px 7px', fontSize: '0.78rem', fontWeight: 'bold' }}>{modoLabel}</span>
                </div>
                <button onClick={() => { setRetoDetalle(null); setPuntosGuerra({}); }} style={{ background: 'none', border: 'none', color: '#475569', cursor: 'pointer', fontSize: '1.1rem' }}>×</button>
              </div>

              {/* Marcador */}
              {!puntosYaCargaron ? (
                <div style={{ background: '#080d14', borderRadius: '10px', padding: '16px', marginBottom: '16px', textAlign: 'center', border: '1px solid #1e293b' }}>
                  <p style={{ color: '#475569', fontSize: '0.88rem', margin: 0 }}>⏳ Cargando puntos...</p>
                </div>
              ) : (nuestros.length > 0 || (suyos||[]).length > 0) ? (
                <div style={{ background: '#080d14', borderRadius: '10px', padding: '12px 16px', marginBottom: '16px', textAlign: 'center', border: `1px solid ${finalizada ? (ganamos ? '#22c55e33' : perdimos ? '#ef444433' : '#1e293b') : '#1e293b'}` }}>
                  {finalizada ? (
                    <p style={{ color: ganamos ? '#22c55e' : perdimos ? '#ef4444' : '#f59e0b', fontWeight: 'bold', fontSize: '0.85rem', margin: '0 0 6px' }}>
                      {ganamos ? ' Victoria' : perdimos ? ' Derrota' : ' Empate'}
                    </p>
                  ) : (
                    <p style={{ color: '#475569', fontSize: '0.78rem', margin: '0 0 6px', textTransform: 'uppercase', letterSpacing: '1px' }}>Puntos jornada actual</p>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px' }}>
                    <span style={{ color: ptsnuestros >= ptssuyos ? '#e2e8f0' : '#475569', fontWeight: 'bold', fontSize: '1.6rem' }}>{ptsnuestros}</span>
                    <span style={{ color: '#334155', fontWeight: 'bold' }}>—</span>
                    <span style={{ color: ptssuyos >= ptsnuestros ? '#e2e8f0' : '#475569', fontWeight: 'bold', fontSize: '1.6rem' }}>{ptssuyos}</span>
                  </div>
                </div>
              ) : null}

              {/* Jugadores */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', gap: '12px', alignItems: 'start', marginBottom: '16px' }}>
                {/* Nuestro equipo */}
                <div>
                  <p style={{ color: miClan?.color||'#00f2ff', fontSize: '0.85rem', fontWeight: 'bold', margin: '0 0 8px', textTransform: 'uppercase' }}>{miClan?.nombre}</p>
                  {nuestros.map(uid => {
                    const m = miembros.find(m => m.user_id === uid);
                    const pts = puntosGuerra[uid];
                    const colorPts = ganamos ? '#22c55e' : perdimos ? '#ef4444' : '#94a3b8';
                    return (
                      <div key={uid} onClick={() => navigate(`/palmares/${uid}`)}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px', padding: '6px 10px', borderRadius: '6px', cursor: 'pointer', marginBottom: '4px', background: '#0a0f19', border: '1px solid #1e293b' }}
                        onMouseEnter={e => e.currentTarget.style.opacity = '0.8'}
                        onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
                        <span style={{ color: '#e2e8f0', fontSize: '0.85rem' }}>{m?.perfiles?.nickname || '?'}</span>
                        <span style={{ color: colorPts, fontWeight: 'bold', fontSize: '0.85rem', minWidth: '48px', textAlign: 'right' }}>{pts != null ? pts + 'pts' : '—'}</span>
                      </div>
                    );
                  })}
                </div>
                <span style={{ color: '#475569', fontWeight: 'bold', fontSize: '1rem', paddingTop: '22px' }}>VS</span>
                {/* Rival */}
                <div>
                  <p style={{ color: rivalClan?.color || '#94a3b8', fontSize: '0.85rem', fontWeight: 'bold', margin: '0 0 8px', textTransform: 'uppercase', textAlign: 'right' }}>
                    {EMBLEMAS[rivalClan?.emblema] || ''} {rivalClan?.nombre || '?'}
                  </p>
                  {(suyos||[]).map((uid) => {
                    const pts = puntosGuerra[uid];
                    const colorPts = perdimos ? '#22c55e' : ganamos ? '#ef4444' : '#94a3b8';
                    return (
                      <div key={uid} onClick={() => navigate(`/palmares/${uid}`)}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px', padding: '6px 10px', borderRadius: '6px', cursor: 'pointer', marginBottom: '4px', background: '#0a0f19', border: '1px solid #1e293b' }}
                        onMouseEnter={e => e.currentTarget.style.opacity = '0.8'}
                        onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
                        <span style={{ color: colorPts, fontWeight: 'bold', fontSize: '0.85rem', minWidth: '48px' }}>{pts != null ? pts + 'pts' : '—'}</span>
                        <span style={{ color: '#94a3b8', fontSize: '0.85rem' }}>{rivalesNicks[uid] || '...'}</span>
                      </div>
                    );
                  })}
                </div>
              </div>

              {g && (
                <p style={{ color: '#475569', fontSize: '0.85rem', textAlign: 'center', margin: 0 }}>
                  Fecha {g.jornada_inicio}{finalizada ? ' · Finalizada' : ''}
                </p>
              )}
            </div>
          </div>
        );
      })()}
    </>
    <Tutorial tutorialId="clan" userId={session.user.id} pasos={TUTORIALES.clan} botonVerDeNuevo={true} />
    </>
  );
};

export default ClanPage;